import React, { useRef, useState, useCallback, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Attachment from "../../../images/attachment.png";
import MissingTooth from "../../../images/missingtooth.png";
import ButtonCutoutBuccal from "../../../images/buttoncutoutbuccal.png";
import ButtonCutoutLingual from "../../../images/buttoncutoutlingual.png";
import Extraction from "../../../images/extraction.png";
import Biteramp from "../../../images/biteramp.png";
import ElasticHookLeft from "../../../images/elastichookleft.png";
import ElasticHookRight from "../../../images/elastichookright.png";
import PressurePoint from "../../../images/presurepoint.png";
import LeftImage from "../../../images/imageLeft.png";
import PowerRidge from "../../../images/tads.png";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { CaseService } from '../../../api/CaseService';
const api_url = process.env.REACT_APP_API_URL;
const CasePlanUploadUpdate = () => {

  const { id } = useParams();

  const currentDate = new Date();
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const UPPER_TEETH_ORDER = ['18', '17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '28'];
  const LOWER_TEETH_ORDER = ['48', '47', '46', '45', '44', '43', '42', '41', '31', '32', '33', '34', '35', '36', '37', '38'];
  const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')} ${months[currentDate.getMonth()]} ${currentDate.getFullYear()}`;

  const pdfRef = useRef(null);
  const specificElementRef = useRef(null);
  const specificElementRef2 = useRef(null);
  const initialSmall = useRef(null);
  const [initialSmallUrl, setInitialSmallUrl] = useState(null);
  const afterSmall = useRef(null);
  const [afterSmallUrl, setAfterSmallUrl] = useState(null);
  const initialLarge1 = useRef(null);
  const [initialLarge1Url, setInitialLarge1Url] = useState(null);
  const initialLarge2 = useRef(null);
  const [initialLarge2Url, setInitialLarge2Url] = useState(null);
  const afterLarge1 = useRef(null);
  const [afterLarge1Url, setAfterLarge1Url] = useState(null);
  const afterLarge2 = useRef(null);
  const [afterLarge2Url, setAfterLarge2Url] = useState(null);
  const [upperHighlightedTeeth, setUpperHighlightedTeeth] = useState(null);
  const [lowerHighlightedTeeth, setLowerHighlightedTeeth] = useState(null);
  const [handePage, setHandlePages] = useState('two')

  const chartRef = useRef(null);
  const iprRefLeft = useRef(null);
  const iprRefRight = useRef(null);
  //general states
  const [caseName, setCaseName] = useState('')
  const [patient, setPatient] = useState("Type...");
  const [patientModal, setPatientModal] = useState(false)
  // const [date, setDate] = useState("");

  const clientName = localStorage.getItem('clientName')
  const [client, setClient] = useState(clientName || "Type ...");
  const [clientModal, setClientModal] = useState(false)
  const [alignersupper, setAlignersupper] = useState('Enter ..');
  const [alignupperModal, setAlignupperModal] = useState(false)
  const [alignerslower, setAlignerslower] = useState('Enter ..');
  const [allignlowerModal, setAllignlowerModal] = useState(false)
  const [daysupper, setDaysupper] = useState('Enter ..');
  const [daysupperModal, setdaysupperModal] = useState(false)
  const [dayslower, setDayslower] = useState('Enter ..');
  const [dayslowerModal, setdayslowerModal] = useState(false)
  const [workdays, setWorkdays] = useState('10')
  const [workdaysModal, setworkdaysModal] = useState(false)
  const [elasticType, setElasticType] = useState('Type ..');
  const [movementChart, setMovementChart] = useState('MOVEMENT CHART')
  const [movementChartUpperData, setMovementChartUpperData] = useState([])
  const [movementChartLowerData, setMovementChartLowerData] = useState([])
  const [hasMovementData, setHasMovementData] = useState(null)
  const [movementModal, setMovementModal] = useState(false)
  const [elasticModal, setElasticModal] = useState(false)
  const [size, setSize] = useState("Type ..")
  const [sizeModal, setSizeModal] = useState(false)
  const [stage1, setStage1] = useState("Select ..")
  const [stage1Modal, setStage1Modal] = useState(false)
  const [stage2, setStage2] = useState("Select ..")
  const [stage2Modal, setStage2Modal] = useState(false)

  //Pressure points states
  const [modalpp1, setModalpp1] = useState(false)
  const [PP1, setPP1] = useState({
    step1: '',
    step2: '',
  });
  const [modalpp2, setModalpp2] = useState(false)
  const [PP2, setPP2] = useState({
    step1: '',
    step2: '',
  });
  const [modalpp3, setModalpp3] = useState(false)
  const [PP3, setPP3] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp4, setModalpp4] = useState(false)
  const [PP4, setPP4] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp5, setModalpp5] = useState(false)
  const [PP5, setPP5] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp6, setModalpp6] = useState(false)
  const [PP6, setPP6] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp7, setModalpp7] = useState(false)
  const [PP7, setPP7] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp8, setModalpp8] = useState(false)
  const [PP8, setPP8] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp9, setModalpp9] = useState(false)
  const [PP9, setPP9] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp10, setModalpp10] = useState(false)
  const [PP10, setPP10] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp11, setModalpp11] = useState(false)
  const [PP11, setPP11] = useState({
    step1: '',
    step2: '',
  })
  const [modalpp12, setModalpp12] = useState(false)
  const [PP12, setPP12] = useState({
    step1: '',
    step2: '',
  })
  const handlePP1 = (event) => {
    const { name, value } = event.target;

    setPP1({
      ...PP1,
      [name]: value,
    });
  };
  const handlePP2 = (event) => {
    const { name, value } = event.target;

    setPP2({
      ...PP2,
      [name]: value,
    });
  };
  const handlePP3 = (event) => {
    const { name, value } = event.target;

    setPP3({
      ...PP3,
      [name]: value,
    });
  };
  const handlePP4 = (event) => {
    const { name, value } = event.target;

    setPP4({
      ...PP4,
      [name]: value,
    });
  };
  const handlePP5 = (event) => {
    const { name, value } = event.target;

    setPP5({
      ...PP5,
      [name]: value,
    });
  };
  const handlePP6 = (event) => {
    const { name, value } = event.target;

    setPP6({
      ...PP6,
      [name]: value,
    });
  };
  const handlePP7 = (event) => {
    const { name, value } = event.target;

    setPP7({
      ...PP7,
      [name]: value,
    });
  };
  const handlePP8 = (event) => {
    const { name, value } = event.target;

    setPP8({
      ...PP8,
      [name]: value,
    });
  };
  const handlePP9 = (event) => {
    const { name, value } = event.target;

    setPP9({
      ...PP9,
      [name]: value,
    });
  };
  const handlePP10 = (event) => {
    const { name, value } = event.target;

    setPP10({
      ...PP10,
      [name]: value,
    });
  };
  const handlePP11 = (event) => {
    const { name, value } = event.target;

    setPP11({
      ...PP11,
      [name]: value,
    });
  };
  const handlePP12 = (event) => {
    const { name, value } = event.target;

    setPP12({
      ...PP12,
      [name]: value,
    });
  };

  //attachment points
  const [modalAP1, setModalAP1] = useState(false)
  const [AP1, setAP1] = useState({
    step1: '',

  })
  const [modalAP2, setModalAP2] = useState(false)
  const [AP2, setAP2] = useState({
    step1: '',
  })
  const [modalAP3, setModalAP3] = useState(false)
  const [AP3, setAP3] = useState({
    step1: '',

  })
  const [modalAP4, setModalAP4] = useState(false)
  const [AP4, setAP4] = useState({
    step1: '',

  })
  const [modalAP5, setModalAP5] = useState(false)
  const [AP5, setAP5] = useState({
    step1: '',

  })
  const [modalAP6, setModalAP6] = useState(false)
  const [AP6, setAP6] = useState({
    step1: '',

  })
  const [modalAP7, setModalAP7] = useState(false)
  const [AP7, setAP7] = useState({
    step1: '',

  })
  const [modalAP8, setModalAP8] = useState(false)
  const [AP8, setAP8] = useState({
    step1: '',

  })
  const [modalAP9, setModalAP9] = useState(false)
  const [AP9, setAP9] = useState({
    step1: '',

  })
  const [modalAP10, setModalAP10] = useState(false)
  const [AP10, setAP10] = useState({
    step1: '',

  })
  const [modalAP11, setModalAP11] = useState(false)
  const [AP11, setAP11] = useState({
    step1: '',

  })
  const [modalAP12, setModalAP12] = useState(false)
  const [AP12, setAP12] = useState({
    step1: '',

  })
  const [modalAP13, setModalAP13] = useState(false)
  const [AP13, setAP13] = useState({
    step1: '',

  })
  const [modalAP14, setModalAP14] = useState(false)
  const [AP14, setAP14] = useState({
    step1: '',

  })
  const [modalAP15, setModalAP15] = useState(false)
  const [AP15, setAP15] = useState({
    step1: '',

  })
  const [modalAP16, setModalAP16] = useState(false)
  const [AP16, setAP16] = useState({
    step1: '',

  })
  const [modalAP17, setModalAP17] = useState(false)
  const [AP17, setAP17] = useState({
    step1: '',

  })
  const [modalAP18, setModalAP18] = useState(false)
  const [AP18, setAP18] = useState({
    step1: '',

  })
  const [modalAP19, setModalAP19] = useState(false)
  const [AP19, setAP19] = useState({
    step1: '',

  })
  const [modalAP20, setModalAP20] = useState(false)
  const [AP20, setAP20] = useState({
    step1: '',

  })
  const [modalAP21, setModalAP21] = useState(false)
  const [AP21, setAP21] = useState({
    step1: '',

  })
  const [modalAP22, setModalAP22] = useState(false)
  const [AP22, setAP22] = useState({
    step1: '',

  })
  const [modalAP23, setModalAP23] = useState(false)
  const [AP23, setAP23] = useState({
    step1: '',

  })
  const [modalAP24, setModalAP24] = useState(false)
  const [AP24, setAP24] = useState({
    step1: '',

  })
  const [modalAP25, setModalAP25] = useState(false)
  const [AP25, setAP25] = useState({
    step1: '',

  })
  const [modalAP26, setModalAP26] = useState(false)
  const [AP26, setAP26] = useState({
    step1: '',

  })
  const [modalAP27, setModalAP27] = useState(false)
  const [AP27, setAP27] = useState({
    step1: '',

  })
  const [modalAP28, setModalAP28] = useState(false)
  const [AP28, setAP28] = useState({
    step1: '',

  })
  const [modalAP29, setModalAP29] = useState(false)
  const [AP29, setAP29] = useState({
    step1: '',

  })
  const [modalAP30, setModalAP30] = useState(false)
  const [AP30, setAP30] = useState({
    step1: '',

  })
  const [modalAP31, setModalAP31] = useState(false)
  const [AP31, setAP31] = useState({
    step1: '',

  })
  const [modalAP32, setModalAP32] = useState(false)
  const [AP32, setAP32] = useState({
    step1: '',

  })
  const handleAP1 = (event) => {
    const { name, value } = event.target;

    setAP1({
      ...AP1,
      [name]: value,
    });
  };
  const handleAP2 = (event) => {
    const { name, value } = event.target;

    setAP2({
      ...AP2,
      [name]: value,
    });
  };
  const handleAP3 = (event) => {
    const { name, value } = event.target;
    setAP3({
      ...AP3,
      [name]: value,
    });
  };
  const handleAP4 = (event) => {
    const { name, value } = event.target;

    setAP4({
      ...AP4,
      [name]: value,
    });
  };
  const handleAP5 = (event) => {
    const { name, value } = event.target;

    setAP5({
      ...AP5,
      [name]: value,
    });
  };
  const handleAP6 = (event) => {
    const { name, value } = event.target;

    setAP6({
      ...AP6,
      [name]: value,
    });
  };
  const handleAP7 = (event) => {
    const { name, value } = event.target;

    setAP7({
      ...AP7,
      [name]: value,
    });
  };
  const handleAP8 = (event) => {
    const { name, value } = event.target;

    setAP8({
      ...AP8,
      [name]: value,
    });
  };
  const handleAP9 = (event) => {
    const { name, value } = event.target;

    setAP9({
      ...AP9,
      [name]: value,
    });
  };
  const handleAP10 = (event) => {
    const { name, value } = event.target;

    setAP10({
      ...AP10,
      [name]: value,
    });
  };
  const handleAP11 = (event) => {
    const { name, value } = event.target;

    setAP11({
      ...AP11,
      [name]: value,
    });
  };
  const handleAP12 = (event) => {
    const { name, value } = event.target;

    setAP12({
      ...AP12,
      [name]: value,
    });
  };
  const handleAP13 = (event) => {
    const { name, value } = event.target;

    setAP13({
      ...AP13,
      [name]: value,
    });
  };
  const handleAP14 = (event) => {
    const { name, value } = event.target;

    setAP14({
      ...AP14,
      [name]: value,
    });
  };
  const handleAP15 = (event) => {
    const { name, value } = event.target;

    setAP15({
      ...AP15,
      [name]: value,
    });
  };
  const handleAP16 = (event) => {
    const { name, value } = event.target;

    setAP16({
      ...AP16,
      [name]: value,
    });
  };
  const handleAP17 = (event) => {
    const { name, value } = event.target;

    setAP17({
      ...AP17,
      [name]: value,
    });
  };
  const handleAP18 = (event) => {
    const { name, value } = event.target;

    setAP18({
      ...AP18,
      [name]: value,
    });
  };
  const handleAP19 = (event) => {
    const { name, value } = event.target;

    setAP19({
      ...AP19,
      [name]: value,
    });
  };
  const handleAP20 = (event) => {
    const { name, value } = event.target;

    setAP20({
      ...AP20,
      [name]: value,
    });
  };
  const handleAP21 = (event) => {
    const { name, value } = event.target;

    setAP21({
      ...AP21,
      [name]: value,
    });
  };
  const handleAP22 = (event) => {
    const { name, value } = event.target;

    setAP22({
      ...AP22,
      [name]: value,
    });
  };
  const handleAP23 = (event) => {
    const { name, value } = event.target;

    setAP23({
      ...AP23,
      [name]: value,
    });
  };
  const handleAP24 = (event) => {
    const { name, value } = event.target;

    setAP24({
      ...AP24,
      [name]: value,
    });
  };
  const handleAP25 = (event) => {
    const { name, value } = event.target;

    setAP25({
      ...AP25,
      [name]: value,
    });
  };
  const handleAP26 = (event) => {
    const { name, value } = event.target;

    setAP26({
      ...AP26,
      [name]: value,
    });
  };
  const handleAP27 = (event) => {
    const { name, value } = event.target;

    setAP27({
      ...AP27,
      [name]: value,
    });
  };
  const handleAP28 = (event) => {
    const { name, value } = event.target;

    setAP28({
      ...AP28,
      [name]: value,
    });
  };
  const handleAP29 = (event) => {
    const { name, value } = event.target;

    setAP29({
      ...AP29,
      [name]: value,
    });
  };
  const handleAP30 = (event) => {
    const { name, value } = event.target;

    setAP30({
      ...AP30,
      [name]: value,
    });
  };
  const handleAP31 = (event) => {
    const { name, value } = event.target;

    setAP31({
      ...AP31,
      [name]: value,
    });
  };
  const handleAP32 = (event) => {
    const { name, value } = event.target;

    setAP32({
      ...AP32,
      [name]: value,
    });
  };

  //irp states
  const [modal1, setModal1] = useState(false)
  const [IRP1, setIRP1] = useState({
    width: '',
    step: '',
  })

  const handleIRP1 = (event) => {
    const { name, value } = event.target;

    setIRP1({
      ...IRP1,
      [name]: value,
    });
  };

  // IRP2
  const [modal2, setModal2] = useState(false)
  const [IRP2, setIRP2] = useState({
    width: '',
    step: '',
  })

  const handleIRP2 = (event) => {
    const { name, value } = event.target;

    setIRP2({
      ...IRP2,
      [name]: value,
    });
  };


  // IRP3
  const [modal3, setModal3] = useState(false)
  const [IRP3, setIRP3] = useState({
    width: '',
    step: '',
  })

  const handleIRP3 = (event) => {
    const { name, value } = event.target;

    setIRP3({
      ...IRP3,
      [name]: value,
    });
  };

  // IRP4
  const [modal4, setModal4] = useState(false)
  const [IRP4, setIRP4] = useState({
    width: '',
    step: '',
  })

  const handleIRP4 = (event) => {
    const { name, value } = event.target;

    setIRP4({
      ...IRP4,
      [name]: value,
    });
  };

  // IRP5
  const [modal5, setModal5] = useState(false)
  const [IRP5, setIRP5] = useState({
    width: '',
    step: '',
  })

  const handleIRP5 = (event) => {
    const { name, value } = event.target;

    setIRP5({
      ...IRP5,
      [name]: value,
    });
  };

  // IRP6
  const [modal6, setModal6] = useState(false)
  const [IRP6, setIRP6] = useState({
    width: '',
    step: '',
  })

  const handleIRP6 = (event) => {
    const { name, value } = event.target;

    setIRP6({
      ...IRP6,
      [name]: value,
    });
  };


  // IRP7
  const [modal7, setModal7] = useState(false)
  const [IRP7, setIRP7] = useState({
    width: '',
    step: '',
  })

  const handleIRP7 = (event) => {
    const { name, value } = event.target;

    setIRP7({
      ...IRP7,
      [name]: value,
    });
  };
  // IRP8
  const [modal8, setModal8] = useState(false)
  const [IRP8, setIRP8] = useState({
    width: '',
    step: '',
  })

  const handleIRP8 = (event) => {
    const { name, value } = event.target;

    setIRP8({
      ...IRP8,
      [name]: value,
    });
  };

  // IRP9
  const [modal9, setModal9] = useState(false)
  const [IRP9, setIRP9] = useState({
    width: '',
    step: '',
  })

  const handleIRP9 = (event) => {
    const { name, value } = event.target;

    setIRP9({
      ...IRP9,
      [name]: value,
    });
  };

  // IRP10
  const [modal10, setModal10] = useState(false)
  const [IRP10, setIRP10] = useState({
    width: '',
    step: '',
  })

  const handleIRP10 = (event) => {
    const { name, value } = event.target;

    setIRP10({
      ...IRP10,
      [name]: value,
    });
  };

  // IRP11
  const [modal11, setModal11] = useState(false)
  const [IRP11, setIRP11] = useState({
    width: '',
    step: '',
  })

  const handleIRP11 = (event) => {
    const { name, value } = event.target;

    setIRP11({
      ...IRP11,
      [name]: value,
    });
  };
  // IRP12
  const [modal12, setModal12] = useState(false)
  const [IRP12, setIRP12] = useState({
    width: '',
    step: '',
  })

  const handleIRP12 = (event) => {
    const { name, value } = event.target;

    setIRP12({
      ...IRP12,
      [name]: value,
    });
  };
  // IRP13
  const [modal13, setModal13] = useState(false)
  const [IRP13, setIRP13] = useState({
    width: '',
    step: '',
  })

  const handleIRP13 = (event) => {
    const { name, value } = event.target;

    setIRP13({
      ...IRP13,
      [name]: value,
    });
  };
  // IRP14
  const [modal14, setModal14] = useState(false)
  const [IRP14, setIRP14] = useState({
    width: '',
    step: '',
  })

  const handleIRP14 = (event) => {
    const { name, value } = event.target;

    setIRP14({
      ...IRP14,
      [name]: value,
    });
  };



  // IRP15
  const [modal15, setModal15] = useState(false)
  const [IRP15, setIRP15] = useState({
    width: '',
    step: '',
  })

  const handleIRP15 = (event) => {
    const { name, value } = event.target;

    setIRP15({
      ...IRP15,
      [name]: value,
    });
  };





  // IRP16
  const [modal16, setModal16] = useState(false)
  const [IRP16, setIRP16] = useState({
    width: '',
    step: '',
  })

  const handleIRP16 = (event) => {
    const { name, value } = event.target;

    setIRP16({
      ...IRP16,
      [name]: value,
    });
  };

  // IRP17
  const [modal17, setModal17] = useState(false)
  const [IRP17, setIRP17] = useState({
    width: '',
    step: '',
  })

  const handleIRP17 = (event) => {
    const { name, value } = event.target;

    setIRP17({
      ...IRP17,
      [name]: value,
    });
  };

  // IRP18
  const [modal18, setModal18] = useState(false)
  const [IRP18, setIRP18] = useState({
    width: '',
    step: '',
  })

  const handleIRP18 = (event) => {
    const { name, value } = event.target;

    setIRP18({
      ...IRP18,
      [name]: value,
    });
  };

  // IRP19
  const [modal19, setModal19] = useState(false)
  const [IRP19, setIRP19] = useState({
    width: '',
    step: '',
  })

  const handleIRP19 = (event) => {
    const { name, value } = event.target;

    setIRP19({
      ...IRP19,
      [name]: value,
    });
  };

  // IRP20
  const [modal20, setModal20] = useState(false)
  const [IRP20, setIRP20] = useState({
    width: '',
    step: '',
  })

  const handleIRP20 = (event) => {
    const { name, value } = event.target;

    setIRP20({
      ...IRP20,
      [name]: value,
    });
  };

  // IRP21
  const [modal21, setModal21] = useState(false)
  const [IRP21, setIRP21] = useState({
    width: '',
    step: '',
  })

  const handleIRP21 = (event) => {
    const { name, value } = event.target;

    setIRP21({
      ...IRP21,
      [name]: value,
    });
  };

  // IRP22
  const [modal22, setModal22] = useState(false)
  const [IRP22, setIRP22] = useState({
    width: '',
    step: '',
  })

  const handleIRP22 = (event) => {
    const { name, value } = event.target;

    setIRP22({
      ...IRP22,
      [name]: value,
    });
  };

  // IRP23
  const [modal23, setModal23] = useState(false)
  const [IRP23, setIRP23] = useState({
    width: '',
    step: '',
  })

  const handleIRP23 = (event) => {
    const { name, value } = event.target;

    setIRP23({
      ...IRP23,
      [name]: value,
    });
  };


  // IRP24
  const [modal24, setModal24] = useState(false)
  const [IRP24, setIRP24] = useState({
    width: '',
    step: '',
  })

  const handleIRP24 = (event) => {
    const { name, value } = event.target;

    setIRP24({
      ...IRP24,
      [name]: value,
    });
  };
  // IRP25
  const [modal25, setModal25] = useState(false)
  const [IRP25, setIRP25] = useState({
    width: '',
    step: '',
  })

  const handleIRP25 = (event) => {
    const { name, value } = event.target;

    setIRP25({
      ...IRP25,
      [name]: value,
    });
  };

  // IRP26
  const [modal26, setModal26] = useState(false)
  const [IRP26, setIRP26] = useState({
    width: '',
    step: '',
  })

  const handleIRP26 = (event) => {
    const { name, value } = event.target;

    setIRP26({
      ...IRP26,
      [name]: value,
    });
  };

  // IRP27
  const [modal27, setModal27] = useState(false)
  const [IRP27, setIRP27] = useState({
    width: '',
    step: '',
  })

  const handleIRP27 = (event) => {
    const { name, value } = event.target;

    setIRP27({
      ...IRP27,
      [name]: value,
    });
  };

  // IRP28
  const [modal28, setModal28] = useState(false)
  const [IRP28, setIRP28] = useState({
    width: '',
    step: '',
  })

  const handleIRP28 = (event) => {
    const { name, value } = event.target;

    setIRP28({
      ...IRP28,
      [name]: value,
    });
  };
  // IRP29
  const [modal29, setModal29] = useState(false)
  const [IRP29, setIRP29] = useState({
    width: '',
    step: '',
  })

  const handleIRP29 = (event) => {
    const { name, value } = event.target;

    setIRP29({
      ...IRP29,
      [name]: value,
    });
  };


  // IRP30
  const [modal30, setModal30] = useState(false)
  const [IRP30, setIRP30] = useState({
    width: '',
    step: '',
  })

  const handleIRP30 = (event) => {
    const { name, value } = event.target;

    setIRP30({
      ...IRP30,
      [name]: value,
    });
  };

  // IRP31
  const [modal31, setModal31] = useState(false)
  const [IRP31, setIRP31] = useState({
    width: '',
    step: '',
  })

  const handleIRP31 = (event) => {
    const { name, value } = event.target;

    setIRP31({
      ...IRP31,
      [name]: value,
    });
  };

  // IRP32
  const [modal32, setModal32] = useState(false)
  const [IRP32, setIRP32] = useState({
    width: '',
    step: '',
  })

  const handleIRP32 = (event) => {
    const { name, value } = event.target;

    setIRP32({
      ...IRP32,
      [name]: value,
    });
  };
  // Callback function to update refs
  const setInitialSmall = useCallback((node) => {
    if (node !== null) {
      initialSmall.current = node;
    }
  }, []);

  const setAfterSmall = useCallback((node) => {
    if (node !== null) {
      afterSmall.current = node;
    }
  }, []);
  const setInitialLarge1 = useCallback((node) => {
    if (node !== null) {
      initialLarge1.current = node;
    }
  }, []);

  const setInitialLarge2 = useCallback((node) => {
    if (node !== null) {
      initialLarge2.current = node;
    }
  }, []);

  const setAfterLarge1 = useCallback((node) => {
    if (node !== null) {
      afterLarge1.current = node;
    }
  }, []);

  const setAfterLarge2 = useCallback((node) => {
    if (node !== null) {
      afterLarge2.current = node;
    }
  }, []);


  //logics for upper right tooths
  //logics for upperrighttooth1
  //  functions to close rest modals
  const [modalNumber, setModalNumber] = useState('')
  const modalNumberFunction = (num) => {

    setModalNumber(num)


  }

  const [openUR1, setOpenUR1] = useState(false);
  const [selectedUR1, setSelectedUR1] = useState([]);
  const [imageMapur1] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR1 = [
    ...new Set(selectedUR1?.map((option) => imageMapur1[option])),
  ];
  const handleUR1 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR1((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR1((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth2
  const [openUR2, setOpenUR2] = useState(false);
  const [selectedUR2, setSelectedUR2] = useState([]);
  const [imageMapur2] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR2 = [
    ...new Set(selectedUR2?.map((option) => imageMapur2[option])),
  ];
  const handleUR2 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR2((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR2((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth3
  const [openUR3, setOpenUR3] = useState(false);
  const [selectedUR3, setSelectedUR3] = useState([]);
  const [imageMapur3] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR3 = [
    ...new Set(selectedUR3?.map((option) => imageMapur3[option])),
  ];
  const handleUR3 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR3((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR3((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth4
  const [openUR4, setOpenUR4] = useState(false);
  const [selectedUR4, setSelectedUR4] = useState([]);
  const [imageMapur4] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR4 = [
    ...new Set(selectedUR4?.map((option) => imageMapur4[option])),
  ];
  const handleUR4 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR4((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR4((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth5
  const [openUR5, setOpenUR5] = useState(false);
  const [selectedUR5, setSelectedUR5] = useState([]);
  const [imageMapur5] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR5 = [
    ...new Set(selectedUR5?.map((option) => imageMapur5[option])),
  ];
  const handleUR5 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR5((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR5((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth6
  const [openUR6, setOpenUR6] = useState(false);
  const [selectedUR6, setSelectedUR6] = useState([]);
  const [imageMapur6] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR6 = [
    ...new Set(selectedUR6?.map((option) => imageMapur6[option])),
  ];
  const handleUR6 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR6((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR6((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth7
  const [openUR7, setOpenUR7] = useState(false);
  const [selectedUR7, setSelectedUR7] = useState([]);
  const [imageMapur7] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR7 = [
    ...new Set(selectedUR7?.map((option) => imageMapur7[option])),
  ];
  const handleUR7 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR7((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR7((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperrighttooth8
  const [openUR8, setOpenUR8] = useState(false);
  const [selectedUR8, setSelectedUR8] = useState([]);
  const [imageMapur8] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUR8 = [
    ...new Set(selectedUR8?.map((option) => imageMapur8[option])),
  ];
  const handleUR8 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUR8((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUR8((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upper left tooths
  //logics for upperlefttooth1
  const [openUL1, setOpenUL1] = useState(false);
  const [selectedUL1, setSelectedUL1] = useState([]);
  const [imageMapul1] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL1 = [
    ...new Set(selectedUL1?.map((option) => imageMapul1[option])),
  ];
  const handleUL1 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL1((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL1((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for upperlefttooth2
  const [openUL2, setOpenUL2] = useState(false);
  const [selectedUL2, setSelectedUL2] = useState([]);
  const [imageMapul2] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL2 = [
    ...new Set(selectedUL2?.map((option) => imageMapul2[option])),
  ];
  const handleUL2 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL2((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL2((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for upperlefttooth3
  const [openUL3, setOpenUL3] = useState(false);
  const [selectedUL3, setSelectedUL3] = useState([]);
  const [imageMapul3] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL3 = [
    ...new Set(selectedUL3?.map((option) => imageMapul3[option])),
  ];
  const handleUL3 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL3((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL3((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for upperlefttooth4
  const [openUL4, setOpenUL4] = useState(false);
  const [selectedUL4, setSelectedUL4] = useState([]);
  const [imageMapul4] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL4 = [
    ...new Set(selectedUL4?.map((option) => imageMapul4[option])),
  ];
  const handleUL4 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL4((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL4((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperlefttooth5
  const [openUL5, setOpenUL5] = useState(false);
  const [selectedUL5, setSelectedUL5] = useState([]);
  const [imageMapul5] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL5 = [
    ...new Set(selectedUL5?.map((option) => imageMapul5[option])),
  ];
  const handleUL5 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL5((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL5((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };




  //logics for upperlefttooth6
  const [openUL6, setOpenUL6] = useState(false);
  const [selectedUL6, setSelectedUL6] = useState([]);
  const [imageMapul6] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL6 = [
    ...new Set(selectedUL6?.map((option) => imageMapul6[option])),
  ];
  const handleUL6 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL6((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL6((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for upperlefttooth7
  const [openUL7, setOpenUL7] = useState(false);
  const [selectedUL7, setSelectedUL7] = useState([]);
  const [imageMapul7] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL7 = [
    ...new Set(selectedUL7?.map((option) => imageMapul7[option])),
  ];
  const handleUL7 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL7((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL7((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };




  //logics for upperlefttooth8
  const [openUL8, setOpenUL8] = useState(false);
  const [selectedUL8, setSelectedUL8] = useState([]);
  const [imageMapul8] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueUL8 = [
    ...new Set(selectedUL8?.map((option) => imageMapul8[option])),
  ];
  const handleUL8 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedUL8((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedUL8((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for lower right tooths
  //logics for lowerrighttooth1
  const [openLR1, setOpenLR1] = useState(false);
  const [selectedLR1, setSelectedLR1] = useState([]);
  const [imageMaplr1] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR1 = [
    ...new Set(selectedLR1?.map((option) => imageMaplr1[option])),
  ];
  const handleLR1 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR1((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR1((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for lowerrighttooth2
  const [openLR2, setOpenLR2] = useState(false);
  const [selectedLR2, setSelectedLR2] = useState([]);
  const [imageMaplr2] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR2 = [
    ...new Set(selectedLR2?.map((option) => imageMaplr2[option])),
  ];
  const handleLR2 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR2((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR2((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for lowerrighttooth3
  const [openLR3, setOpenLR3] = useState(false);
  const [selectedLR3, setSelectedLR3] = useState([]);
  const [imageMaplr3] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR3 = [
    ...new Set(selectedLR3?.map((option) => imageMaplr3[option])),
  ];
  const handleLR3 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR3((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR3((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };


  //logics for lowerrighttooth4
  const [openLR4, setOpenLR4] = useState(false);
  const [selectedLR4, setSelectedLR4] = useState([]);
  const [imageMaplr4] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR4 = [
    ...new Set(selectedLR4?.map((option) => imageMaplr4[option])),
  ];
  const handleLR4 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR4((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR4((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };




  //logics for lowerrighttooth5
  const [openLR5, setOpenLR5] = useState(false);
  const [selectedLR5, setSelectedLR5] = useState([]);
  const [imageMaplr5] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR5 = [
    ...new Set(selectedLR5?.map((option) => imageMaplr5[option])),
  ];
  const handleLR5 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR5((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR5((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for lowerrighttooth6
  const [openLR6, setOpenLR6] = useState(false);
  const [selectedLR6, setSelectedLR6] = useState([]);
  const [imageMaplr6] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR6 = [
    ...new Set(selectedLR6?.map((option) => imageMaplr6[option])),
  ];
  const handleLR6 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR6((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR6((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };


  //logics for lowerrighttooth7
  const [openLR7, setOpenLR7] = useState(false);
  const [selectedLR7, setSelectedLR7] = useState([]);
  const [imageMaplr7] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR7 = [
    ...new Set(selectedLR7?.map((option) => imageMaplr7[option])),
  ];
  const handleLR7 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR7((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR7((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };


  //logics for lowerrighttooth8
  const [openLR8, setOpenLR8] = useState(false);
  const [selectedLR8, setSelectedLR8] = useState([]);
  const [imageMaplr8] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLR8 = [
    ...new Set(selectedLR8?.map((option) => imageMaplr8[option])),
  ];
  const handleLR8 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLR8((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLR8((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };


  //logics for lower left section

  //logics for lowerlefttooth1
  const [openLL1, setOpenLL1] = useState(false);
  const [selectedLL1, setSelectedLL1] = useState([]);
  const [imageMapll1] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL1 = [
    ...new Set(selectedLL1?.map((option) => imageMapll1[option])),
  ];
  const handleLL1 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL1((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL1((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };


  //logics for lowerlefttooth2
  const [openLL2, setOpenLL2] = useState(false);
  const [selectedLL2, setSelectedLL2] = useState([]);
  const [imageMapll2] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL2 = [
    ...new Set(selectedLL2?.map((option) => imageMapll2[option])),
  ];
  const handleLL2 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL2((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL2((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  //logics for lowerlefttooth3
  const [openLL3, setOpenLL3] = useState(false);
  const [selectedLL3, setSelectedLL3] = useState([]);
  const [imageMapll3] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL3 = [
    ...new Set(selectedLL3?.map((option) => imageMapll3[option])),
  ];
  const handleLL3 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL3((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL3((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for lowerlefttooth2
  const [openLL4, setOpenLL4] = useState(false);
  const [selectedLL4, setSelectedLL4] = useState([]);
  const [imageMapll4] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL4 = [
    ...new Set(selectedLL4?.map((option) => imageMapll4[option])),
  ];
  const handleLL4 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL4((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL4((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };


  //logics for lowerlefttooth5
  const [openLL5, setOpenLL5] = useState(false);
  const [selectedLL5, setSelectedLL5] = useState([]);
  const [imageMapll5] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL5 = [
    ...new Set(selectedLL5?.map((option) => imageMapll5[option])),
  ];
  const handleLL5 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL5((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL5((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for lowerlefttooth6
  const [openLL6, setOpenLL6] = useState(false);
  const [selectedLL6, setSelectedLL6] = useState([]);
  const [imageMapll6] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL6 = [
    ...new Set(selectedLL6?.map((option) => imageMapll6[option])),
  ];
  const handleLL6 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL6((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL6((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for lowerlefttooth7
  const [openLL7, setOpenLL7] = useState(false);
  const [selectedLL7, setSelectedLL7] = useState([]);
  const [imageMapll7] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL7 = [
    ...new Set(selectedLL7?.map((option) => imageMapll7[option])),
  ];
  const handleLL7 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL7((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL7((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };



  //logics for lowerlefttooth8
  const [openLL8, setOpenLL8] = useState(false);
  const [selectedLL8, setSelectedLL8] = useState([]);
  const [imageMapll8] = useState({
    Attachment: Attachment,
    "Missing Tooth": MissingTooth,
    "Button Cutout Buccal": ButtonCutoutBuccal,
    "Button Cutout Lingual": ButtonCutoutLingual,
    Extraction: Extraction,
    Biteramp: Biteramp,
    "Elastic Hook Left": ElasticHookLeft,
    "Elastic Hook Right": ElasticHookRight,
    "Pressure Point": PressurePoint,
    PowerRidge: PowerRidge,
  });
  const uniqueLL8 = [
    ...new Set(selectedLL8?.map((option) => imageMapll8[option])),
  ];
  const handleLL8 = (event) => {
    const option = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedLL8((prevSelected) => [...prevSelected, option]);
    } else {
      setSelectedLL8((prevSelected) =>
        prevSelected.filter((selectedOption) => selectedOption !== option)
      );
    }
  };

  const handleInitialSmall = (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;

    for (let index in items) {
      const item = items[index];

      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          setInitialSmallUrl(imageUrl);
        };

        reader.readAsDataURL(blob);
      }
    }
  };

  //handle initial small
  const handleAfterSmall = (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;

    for (let index in items) {
      const item = items[index];

      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          setAfterSmallUrl(imageUrl);
        };

        reader.readAsDataURL(blob);
      }
    }
  };

  //handle initial large
  const handleInitialLarge1 = (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    for (let index in items) {
      const item = items[index];

      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          setInitialLarge1Url(imageUrl);
        };

        reader.readAsDataURL(blob);
      }
    }
  };

  const handleInitialLarge2 = (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    for (let index in items) {
      const item = items[index];

      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          setInitialLarge2Url(imageUrl);
        };

        reader.readAsDataURL(blob);
      }
    }
  };

  //handle after large
  const handleAfterLarge1 = (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;

    for (let index in items) {
      const item = items[index];

      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          setAfterLarge1Url(imageUrl);
        };

        reader.readAsDataURL(blob);
      }
    }
  };

  const handleAfterLarge2 = (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;

    for (let index in items) {
      const item = items[index];

      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          setAfterLarge2Url(imageUrl);
        };

        reader.readAsDataURL(blob);
      }
    }
  };

  //handle IPR LEft
  const handleIprLeft = (event) => {

    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    for (let index in items) {
      const item = items[index];
      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          // img.style.objectFit = "contain";

          // Clear existing content of the correct div
          iprRefLeft.current.innerHTML = "";

          // Append the new image to the correct div
          iprRefLeft.current.appendChild(img);
        };
        reader.readAsDataURL(blob);
      }
    }
  };
  //handle IPR Right
  const handleIprRight = (event) => {

    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    for (let index in items) {
      const item = items[index];
      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          // img.style.objectFit = "contain";

          // Clear existing content of the correct div
          iprRefRight.current.innerHTML = "";

          // Append the new image to the correct div
          iprRefRight.current.appendChild(img);
        };
        reader.readAsDataURL(blob);
      }
    }
  };

  //handle IPR Right
  const handleChartRef = (event) => {

    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    for (let index in items) {
      const item = items[index];
      if (item.kind === "file") {
        const blob = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          // img.style.objectFit = "contain";

          // Clear existing content of the correct div
          chartRef.current.innerHTML = "";

          // Append the new image to the correct div
          chartRef.current.appendChild(img);
        };
        reader.readAsDataURL(blob);
      }
    }
  };




  // const generatePDF = () => {
  //   const input = pdfRef.current;
  //   const specificElement = specificElementRef.current;
  //   const specificElement2 = specificElementRef2.current;
  //   html2canvas(specificElement, { scrollY: -window.scrollY }).then((specificCanvas) => {
  //     const specificImgData = specificCanvas.toDataURL("image/jpeg", 1.0);

  //     // Capture the entire content
  //     html2canvas(input, { scrollY: -window.scrollY }).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/jpeg", 1.0);
  //       const pdf = new jsPDF({
  //         orientation: 'portrait',
  //         unit: 'mm',
  //         format: [canvas.width * 0.264583, canvas.height * 0.264583],
  //       });
  //       const pdfWidth = pdf.internal.pageSize.getWidth();
  //       const pdfHeight = pdf.internal.pageSize.getHeight();
  //       const imgWidth = canvas.width;
  //       const imgHeight = canvas.height;
  //       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

  //       // Add the first page
  //       pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
  //       pdf.addPage(); // Add a new page

  //       // Add the second page
  //       pdf.addImage(specificImgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
  //       pdf.addPage(); // Add a new page

  //       // Capture another specific content for the third page
  //       html2canvas(specificElement2, { scrollY: -window.scrollY }).then((anotherSpecificCanvas) => {
  //         const anotherSpecificImgData = anotherSpecificCanvas.toDataURL("image/jpeg", 1.0);

  //         // Add the content of the specific element to the third page
  //         pdf.addImage(anotherSpecificImgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

  //         // Save the PDF
  //         pdf.save(`${caseName ? caseName + '.pdf' : 'download.pdf'}`);
  //       });
  //     });
  //   });
  // };


  const generatePDF = async () => {
    // Ensure that all required refs are currently pointing to a DOM element.
    // The logic for the third page is now conditional.
    if (!pdfRef.current || !specificElementRef.current) {
      console.error("The main PDF elements are not available.");
      return;
    }

    // Optional: You might want to show a loading spinner or disable the button here
    // setIsLoading(true);

    try {
      const inputElement = pdfRef.current;
      const specificElement1 = specificElementRef.current;

      // Common options for html2canvas
      const html2canvasOptions = {
        scrollY: -window.scrollY,
        useCORS: true,
      };

      // Capture the entire content (pdfRef)
      const mainCanvas = await html2canvas(inputElement, html2canvasOptions);
      const mainImgData = mainCanvas.toDataURL("image/jpeg", 1.0);

      // Capture the first specific element (specificElementRef)
      const specificCanvas1 = await html2canvas(specificElement1, html2canvasOptions);
      const specificImgData1 = specificCanvas1.toDataURL("image/jpeg", 1.0);

      // Initialize jsPDF with dimensions based on the main content's capture.
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [mainCanvas.width * 0.264583, mainCanvas.height * 0.264583],
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const addImageToPdfPage = (imageInstance, canvasForDimensions) => {
        const imgWidth = canvasForDimensions.width;
        const imgHeight = canvasForDimensions.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const finalImgWidth = imgWidth * ratio;
        const finalImgHeight = imgHeight * ratio;
        const posX = (pdfWidth - finalImgWidth) / 2;
        const posY = (pdfHeight - finalImgHeight) / 2;
        pdf.addImage(imageInstance, "JPEG", posX, posY, finalImgWidth, finalImgHeight);
      };

      // Add the main content as the first page
      addImageToPdfPage(mainImgData, mainCanvas);

      // Add a new page for the first specific element
      pdf.addPage();
      addImageToPdfPage(specificImgData1, specificCanvas1);

      // Conditionally check if the third page should be added
      if (handePage === 'three' && specificElementRef2.current) {
        const specificElement2 = specificElementRef2.current;
        const specificCanvas2 = await html2canvas(specificElement2, html2canvasOptions);
        const specificImgData2 = specificCanvas2.toDataURL("image/jpeg", 1.0);

        // Add a new page for the second specific element
        pdf.addPage();
        addImageToPdfPage(specificImgData2, specificCanvas2);
      }

      // Save the PDF
      pdf.save(`${caseName ? caseName + '.pdf' : 'download.pdf'}`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      // Optional: Hide loading spinner or re-enable button
      // setIsLoading(false);
    }
  };

  const getHighlightedTeeth = (dataArray, teethOrder) => {
    const highlightedTeeth = new Set();
    if (dataArray) {
      dataArray.forEach(row => {
        if (row.title.includes('+/-')) {
          teethOrder.forEach(toothNumber => {
            // Check if the value is present (not null, undefined, or empty string)
            if (row[toothNumber] !== null && row[toothNumber] !== undefined && row[toothNumber] !== '') {
              highlightedTeeth.add(toothNumber);
            }
          });
        }
      });
    }
    return highlightedTeeth;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await CaseService.getCasePlanUploadDetail(id);
        console.log(result);

        if (result?.data?.success) {

          setHasMovementData(result?.data?.data?.upper_movement?.length > 0 || result?.data?.data?.lower_movement?.length > 0);

          if (result?.data?.data?.upper_movement?.length > 0) {
            setMovementChartUpperData(result?.data?.data?.upper_movement)
            setUpperHighlightedTeeth(getHighlightedTeeth(result.data.data.upper_movement, UPPER_TEETH_ORDER));
          }

          if (result?.data?.data?.lower_movement?.length > 0) {
            setMovementChartLowerData(result?.data?.data?.lower_movement)
            setLowerHighlightedTeeth(getHighlightedTeeth(result.data.data.lower_movement, LOWER_TEETH_ORDER));
          }

          if (result?.data?.data?.upload_payload?.alignersupper) {
            setAlignersupper(result?.data?.data?.upload_payload?.alignersupper);
          }

          if (result?.data?.data?.upload_payload?.alignerslower) {
            setAlignerslower(result?.data?.data?.upload_payload?.alignerslower);
          }

          if (result?.data?.data?.upload_payload?.initialSmall) {
            const storagePath = result.data.data.upload_payload.initialSmall;
            const corsImagePath = storagePath.replace('/storage/pics/', '/cors-images/');
            const fullImageUrl = `${api_url}${corsImagePath}`;
            setInitialSmallUrl(fullImageUrl);
          }

          if (result?.data?.data?.upload_payload?.afterSmall) {
            const storagePath = result.data.data.upload_payload.afterSmall;
            const corsImagePath = storagePath.replace('/storage/pics/', '/cors-images/');
            const fullImageUrl = `${api_url}${corsImagePath}`;
            setAfterSmallUrl(fullImageUrl);
          }

          if (result?.data?.data?.upload_payload?.afterLarge1) {
            const storagePath = result.data.data.upload_payload.afterLarge1;
            const corsImagePath = storagePath.replace('/storage/pics/', '/cors-images/');
            const fullImageUrl = `${api_url}${corsImagePath}`;
            setAfterLarge1Url(fullImageUrl);
          }

          if (result?.data?.data?.upload_payload?.afterLarge2) {
            const storagePath = result.data.data.upload_payload.afterLarge2;
            const corsImagePath = storagePath.replace('/storage/pics/', '/cors-images/');
            const fullImageUrl = `${api_url}${corsImagePath}`;
            setAfterLarge2Url(fullImageUrl);
          }

          if (result?.data?.data?.upload_payload?.initialLarge1) {
            const storagePath = result.data.data.upload_payload.initialLarge1;
            const corsImagePath = storagePath.replace('/storage/pics/', '/cors-images/');
            const fullImageUrl = `${api_url}${corsImagePath}`;
            setInitialLarge1Url(fullImageUrl);
          }

          if (result?.data?.data?.upload_payload?.initialLarge2) {
            const storagePath = result.data.data.upload_payload.initialLarge2;
            const corsImagePath = storagePath.replace('/storage/pics/', '/cors-images/');
            const fullImageUrl = `${api_url}${corsImagePath}`;
            setInitialLarge2Url(fullImageUrl);
          }

          setPatient(result?.data?.data?.patient_name);
          setCaseName(result?.data?.data?.case_number);

          // Set Pressure Point States
          setPP1({
            step1: result?.data?.data?.upload_payload?.PP1_step1,
            step2: result?.data?.data?.upload_payload?.PP1_step2
          });

          setPP2({
            step1: result?.data?.data?.upload_payload?.PP2_step1,
            step2: result?.data?.data?.upload_payload?.PP2_step2
          });

          setPP3({
            step1: result?.data?.data?.upload_payload?.PP3_step1,
            step2: result?.data?.data?.upload_payload?.PP3_step2
          });
          setPP4({
            step1: result?.data?.data?.upload_payload?.PP4_step1,
            step2: result?.data?.data?.upload_payload?.PP4_step2
          });
          setPP5({
            step1: result?.data?.data?.upload_payload?.PP5_step1,
            step2: result?.data?.data?.upload_payload?.PP5_step2
          });
          setPP6({
            step1: result?.data?.data?.upload_payload?.PP6_step1,
            step2: result?.data?.data?.upload_payload?.PP6_step2
          });
          setPP7({
            step1: result?.data?.data?.upload_payload?.PP7_step1,
            step2: result?.data?.data?.upload_payload?.PP7_step2
          });
          setPP8({
            step1: result?.data?.data?.upload_payload?.PP8_step1,
            step2: result?.data?.data?.upload_payload?.PP8_step2
          });
          setPP9({
            step1: result?.data?.data?.upload_payload?.PP9_step1,
            step2: result?.data?.data?.upload_payload?.PP9_step2
          });
          setPP10({
            step1: result?.data?.data?.upload_payload?.PP10_step1,
            step2: result?.data?.data?.upload_payload?.PP10_step2
          });
          setPP11({
            step1: result?.data?.data?.upload_payload?.PP11_step1,
            step2: result?.data?.data?.upload_payload?.PP11_step2
          });
          setPP12({
            step1: result?.data?.data?.upload_payload?.PP12_step1,
            step2: result?.data?.data?.upload_payload?.PP12_step2
          });

          // Set Attachment Point States
          // setAP1({ step1: result?.data?.data?.upload_payload?.AP1_step });
          // setAP2({ step1: result?.data?.data?.upload_payload?.AP2_step });
          // setAP3({ step1: result?.data?.data?.upload_payload?.AP3_step });
          // setAP4({ step1: result?.data?.data?.upload_payload?.AP4_step });
          // setAP5({ step1: result?.data?.data?.upload_payload?.AP5_step });
          // setAP6({ step1: result?.data?.data?.upload_payload?.AP6_step });
          // setAP7({ step1: result?.data?.data?.upload_payload?.AP7_step });
          // setAP8({ step1: result?.data?.data?.upload_payload?.AP8_step });
          // setAP9({ step1: result?.data?.data?.upload_payload?.AP9_step });
          // setAP10({ step1: result?.data?.data?.upload_payload?.AP10_step });
          // setAP11({ step1: result?.data?.data?.upload_payload?.AP11_step });
          // setAP12({ step1: result?.data?.data?.upload_payload?.AP12_step });
          // setAP13({ step1: result?.data?.data?.upload_payload?.AP13_step });
          // setAP14({ step1: result?.data?.data?.upload_payload?.AP14_step });
          // setAP15({ step1: result?.data?.data?.upload_payload?.AP15_step });
          // setAP16({ step1: result?.data?.data?.upload_payload?.AP16_step });
          // setAP17({ step1: result?.data?.data?.upload_payload?.AP17_step });
          // setAP18({ step1: result?.data?.data?.upload_payload?.AP18_step });
          // setAP19({ step1: result?.data?.data?.upload_payload?.AP19_step });
          // setAP20({ step1: result?.data?.data?.upload_payload?.AP20_step });
          // setAP21({ step1: result?.data?.data?.upload_payload?.AP21_step });
          // setAP22({ step1: result?.data?.data?.upload_payload?.AP22_step });
          // setAP23({ step1: result?.data?.data?.upload_payload?.AP23_step });
          // setAP24({ step1: result?.data?.data?.upload_payload?.AP24_step });
          // setAP25({ step1: result?.data?.data?.upload_payload?.AP25_step });
          // setAP26({ step1: result?.data?.data?.upload_payload?.AP26_step });
          // setAP27({ step1: result?.data?.data?.upload_payload?.AP27_step });
          // setAP28({ step1: result?.data?.data?.upload_payload?.AP28_step });
          // setAP29({ step1: result?.data?.data?.upload_payload?.AP29_step });
          // setAP30({ step1: result?.data?.data?.upload_payload?.AP30_step });
          // setAP31({ step1: result?.data?.data?.upload_payload?.AP31_step });
          // setAP32({ step1: result?.data?.data?.upload_payload?.AP32_step });

          // Set IPR States
          setIRP1({
            step: result?.data?.data?.upload_payload?.IPR1_step,
            width: result?.data?.data?.upload_payload?.IPR1_width
          });
          setIRP2({
            step: result?.data?.data?.upload_payload?.IPR2_step,
            width: result?.data?.data?.upload_payload?.IPR2_width
          });
          setIRP3({
            step: result?.data?.data?.upload_payload?.IPR3_step,
            width: result?.data?.data?.upload_payload?.IPR3_width
          });
          setIRP4({
            step: result?.data?.data?.upload_payload?.IPR4_step,
            width: result?.data?.data?.upload_payload?.IPR4_width
          });
          setIRP5({
            step: result?.data?.data?.upload_payload?.IPR5_step,
            width: result?.data?.data?.upload_payload?.IPR5_width
          });
          setIRP6({
            step: result?.data?.data?.upload_payload?.IPR6_step,
            width: result?.data?.data?.upload_payload?.IPR6_width
          });
          setIRP7({
            step: result?.data?.data?.upload_payload?.IPR7_step,
            width: result?.data?.data?.upload_payload?.IPR7_width
          });
          setIRP8({
            step: result?.data?.data?.upload_payload?.IPR8_step,
            width: result?.data?.data?.upload_payload?.IPR8_width
          });
          setIRP9({
            step: result?.data?.data?.upload_payload?.IPR9_step,
            width: result?.data?.data?.upload_payload?.IPR9_width
          });
          setIRP10({
            step: result?.data?.data?.upload_payload?.IPR10_step,
            width: result?.data?.data?.upload_payload?.IPR10_width
          });
          setIRP11({
            step: result?.data?.data?.upload_payload?.IPR11_step,
            width: result?.data?.data?.upload_payload?.IPR11_width
          });
          setIRP12({
            step: result?.data?.data?.upload_payload?.IPR12_step,
            width: result?.data?.data?.upload_payload?.IPR12_width
          });
          setIRP13({
            step: result?.data?.data?.upload_payload?.IPR13_step,
            width: result?.data?.data?.upload_payload?.IPR13_width
          });
          setIRP14({
            step: result?.data?.data?.upload_payload?.IPR14_step,
            width: result?.data?.data?.upload_payload?.IPR14_width
          });
          setIRP15({
            step: result?.data?.data?.upload_payload?.IPR15_step,
            width: result?.data?.data?.upload_payload?.IPR15_width
          });
          setIRP16({
            step: result?.data?.data?.upload_payload?.IPR16_step,
            width: result?.data?.data?.upload_payload?.IPR16_width
          });
          setIRP17({
            step: result?.data?.data?.upload_payload?.IPR17_step,
            width: result?.data?.data?.upload_payload?.IPR17_width
          });
          setIRP18({
            step: result?.data?.data?.upload_payload?.IPR18_step,
            width: result?.data?.data?.upload_payload?.IPR18_width
          });
          setIRP19({
            step: result?.data?.data?.upload_payload?.IPR19_step,
            width: result?.data?.data?.upload_payload?.IPR19_width
          });
          setIRP20({
            step: result?.data?.data?.upload_payload?.IPR20_step,
            width: result?.data?.data?.upload_payload?.IPR20_width
          });
          setIRP21({
            step: result?.data?.data?.upload_payload?.IPR21_step,
            width: result?.data?.data?.upload_payload?.IPR21_width
          });
          setIRP22({
            step: result?.data?.data?.upload_payload?.IPR22_step,
            width: result?.data?.data?.upload_payload?.IPR22_width
          });
          setIRP23({
            step: result?.data?.data?.upload_payload?.IPR23_step,
            width: result?.data?.data?.upload_payload?.IPR23_width
          });
          setIRP24({
            step: result?.data?.data?.upload_payload?.IPR24_step,
            width: result?.data?.data?.upload_payload?.IPR24_width
          });
          setIRP25({
            step: result?.data?.data?.upload_payload?.IPR25_step,
            width: result?.data?.data?.upload_payload?.IPR25_width
          });
          setIRP26({
            step: result?.data?.data?.upload_payload?.IPR26_step,
            width: result?.data?.data?.upload_payload?.IPR26_width
          });
          setIRP27({
            step: result?.data?.data?.upload_payload?.IPR27_step,
            width: result?.data?.data?.upload_payload?.IPR27_width
          });
          setIRP28({
            step: result?.data?.data?.upload_payload?.IPR28_step,
            width: result?.data?.data?.upload_payload?.IPR28_width
          });

          if (result?.data?.data?.upload_payload?.IPR29_step || result?.data?.data?.upload_payload?.IPR29_width) {
            setIRP29({
              step: result?.data?.data?.upload_payload?.IPR29_step,
              width: result?.data?.data?.upload_payload?.IPR29_width
            });
          } else if (result?.data?.data?.upload_payload?.IPR30_step || result?.data?.data?.upload_payload?.IPR30_width) {
            setIRP30({
              step: result?.data?.data?.upload_payload?.IPR30_step,
              width: result?.data?.data?.upload_payload?.IPR30_width
            });
          }

          if (result?.data?.data?.upload_payload?.IPR31_step || result?.data?.data?.upload_payload?.IPR31_width) {
            setIRP31({
              step: result?.data?.data?.upload_payload?.IPR31_step,
              width: result?.data?.data?.upload_payload?.IPR31_width
            });
          } else if (result?.data?.data?.upload_payload?.IPR32_step || result?.data?.data?.upload_payload?.IPR32_width) {
            setIRP32({
              step: result?.data?.data?.upload_payload?.IPR32_step,
              width: result?.data?.data?.upload_payload?.IPR32_width
            });
          }

          // Set Attachments States
          // Iteration for selectedUR1 (tooth 11)
          if (result?.data?.data?.attachments?.['11']) {
            const attachmentsFor11 = result.data.data.attachments['11'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor11.length; i++) {
              newSelections.push(attachmentsFor11[i].Name);
            }
            setSelectedUR1(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR2 (tooth 12)
          if (result?.data?.data?.attachments?.['12']) {
            const attachmentsFor12 = result.data.data.attachments['12'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor12.length; i++) {
              newSelections.push(attachmentsFor12[i].Name);
            }
            setSelectedUR2(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR3 (tooth 13)
          if (result?.data?.data?.attachments?.['13']) {
            const attachmentsFor13 = result.data.data.attachments['13'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor13.length; i++) {
              newSelections.push(attachmentsFor13[i].Name);
            }
            setSelectedUR3(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR4 (tooth 14)
          if (result?.data?.data?.attachments?.['14']) {
            const attachmentsFor14 = result.data.data.attachments['14'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor14.length; i++) {
              newSelections.push(attachmentsFor14[i].Name);
            }
            setSelectedUR4(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR5 (tooth 15)
          if (result?.data?.data?.attachments?.['15']) {
            const attachmentsFor15 = result.data.data.attachments['15'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor15.length; i++) {
              newSelections.push(attachmentsFor15[i].Name);
            }
            setSelectedUR5(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR6 (tooth 16)
          if (result?.data?.data?.attachments?.['16']) {
            const attachmentsFor16 = result.data.data.attachments['16'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor16.length; i++) {
              newSelections.push(attachmentsFor16[i].Name);
            }
            setSelectedUR6(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR7 (tooth 17)
          if (result?.data?.data?.attachments?.['17']) {
            const attachmentsFor17 = result.data.data.attachments['17'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor17.length; i++) {
              newSelections.push(attachmentsFor17[i].Name);
            }
            setSelectedUR7(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUR8 (tooth 18)
          if (result?.data?.data?.attachments?.['18']) {
            const attachmentsFor18 = result.data.data.attachments['18'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor18.length; i++) {
              newSelections.push(attachmentsFor18[i].Name);
            }
            setSelectedUR8(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL1 (tooth 21)
          if (result?.data?.data?.attachments?.['21']) {
            const attachmentsFor21 = result.data.data.attachments['21'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor21.length; i++) {
              newSelections.push(attachmentsFor21[i].Name);
            }
            setSelectedUL1(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL2 (tooth 22)
          if (result?.data?.data?.attachments?.['22']) {
            const attachmentsFor22 = result.data.data.attachments['22'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor22.length; i++) {
              newSelections.push(attachmentsFor22[i].Name);
            }
            setSelectedUL2(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL3 (tooth 23)
          if (result?.data?.data?.attachments?.['23']) {
            const attachmentsFor23 = result.data.data.attachments['23'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor23.length; i++) {
              newSelections.push(attachmentsFor23[i].Name);
            }
            setSelectedUL3(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL4 (tooth 24)
          if (result?.data?.data?.attachments?.['24']) {
            const attachmentsFor24 = result.data.data.attachments['24'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor24.length; i++) {
              newSelections.push(attachmentsFor24[i].Name);
            }
            setSelectedUL4(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL5 (tooth 25)
          if (result?.data?.data?.attachments?.['25']) {
            const attachmentsFor25 = result.data.data.attachments['25'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor25.length; i++) {
              newSelections.push(attachmentsFor25[i].Name);
            }
            setSelectedUL5(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL6 (tooth 26)
          if (result?.data?.data?.attachments?.['26']) {
            const attachmentsFor26 = result.data.data.attachments['26'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor26.length; i++) {
              newSelections.push(attachmentsFor26[i].Name);
            }
            setSelectedUL6(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL7 (tooth 27)
          if (result?.data?.data?.attachments?.['27']) {
            const attachmentsFor27 = result.data.data.attachments['27'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor27.length; i++) {
              newSelections.push(attachmentsFor27[i].Name);
            }
            setSelectedUL7(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedUL8 (tooth 28)
          if (result?.data?.data?.attachments?.['28']) {
            const attachmentsFor28 = result.data.data.attachments['28'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor28.length; i++) {
              newSelections.push(attachmentsFor28[i].Name);
            }
            setSelectedUL8(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR1 (tooth 41)
          if (result?.data?.data?.attachments?.['41']) {
            const attachmentsFor41 = result.data.data.attachments['41'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor41.length; i++) {
              newSelections.push(attachmentsFor41[i].Name);
            }
            setSelectedLR1(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR2 (tooth 42)
          if (result?.data?.data?.attachments?.['42']) {
            const attachmentsFor42 = result.data.data.attachments['42'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor42.length; i++) {
              newSelections.push(attachmentsFor42[i].Name);
            }
            setSelectedLR2(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR3 (tooth 43)
          if (result?.data?.data?.attachments?.['43']) {
            const attachmentsFor43 = result.data.data.attachments['43'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor43.length; i++) {
              newSelections.push(attachmentsFor43[i].Name);
            }
            setSelectedLR3(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR4 (tooth 44)
          if (result?.data?.data?.attachments?.['44']) {
            const attachmentsFor44 = result.data.data.attachments['44'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor44.length; i++) {
              newSelections.push(attachmentsFor44[i].Name);
            }
            setSelectedLR4(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR5 (tooth 45)
          if (result?.data?.data?.attachments?.['45']) {
            const attachmentsFor45 = result.data.data.attachments['45'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor45.length; i++) {
              newSelections.push(attachmentsFor45[i].Name);
            }
            setSelectedLR5(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR6 (tooth 46)
          if (result?.data?.data?.attachments?.['46']) {
            const attachmentsFor46 = result.data.data.attachments['46'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor46.length; i++) {
              newSelections.push(attachmentsFor46[i].Name);
            }
            setSelectedLR6(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR7 (tooth 47)
          if (result?.data?.data?.attachments?.['47']) {
            const attachmentsFor47 = result.data.data.attachments['47'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor47.length; i++) {
              newSelections.push(attachmentsFor47[i].Name);
            }
            setSelectedLR7(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLR8 (tooth 48)
          if (result?.data?.data?.attachments?.['48']) {
            const attachmentsFor48 = result.data.data.attachments['48'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor48.length; i++) {
              newSelections.push(attachmentsFor48[i].Name);
            }
            setSelectedLR8(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL1 (tooth 31)
          if (result?.data?.data?.attachments?.['31']) {
            const attachmentsFor31 = result.data.data.attachments['31'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor31.length; i++) {
              newSelections.push(attachmentsFor31[i].Name);
            }
            setSelectedLL1(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL2 (tooth 32)
          if (result?.data?.data?.attachments?.['32']) {
            const attachmentsFor32 = result.data.data.attachments['32'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor32.length; i++) {
              newSelections.push(attachmentsFor32[i].Name);
            }
            setSelectedLL2(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL3 (tooth 33)
          if (result?.data?.data?.attachments?.['33']) {
            const attachmentsFor33 = result.data.data.attachments['33'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor33.length; i++) {
              newSelections.push(attachmentsFor33[i].Name);
            }
            setSelectedLL3(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL4 (tooth 34)
          if (result?.data?.data?.attachments?.['34']) {
            const attachmentsFor34 = result.data.data.attachments['34'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor34.length; i++) {
              newSelections.push(attachmentsFor34[i].Name);
            }
            setSelectedLL4(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL5 (tooth 35)
          if (result?.data?.data?.attachments?.['35']) {
            const attachmentsFor35 = result.data.data.attachments['35'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor35.length; i++) {
              newSelections.push(attachmentsFor35[i].Name);
            }
            setSelectedLL5(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL6 (tooth 36)
          if (result?.data?.data?.attachments?.['36']) {
            const attachmentsFor36 = result.data.data.attachments['36'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor36.length; i++) {
              newSelections.push(attachmentsFor36[i].Name);
            }
            setSelectedLL6(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL7 (tooth 37)
          if (result?.data?.data?.attachments?.['37']) {
            const attachmentsFor37 = result.data.data.attachments['37'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor37.length; i++) {
              newSelections.push(attachmentsFor37[i].Name);
            }
            setSelectedLL7(prevSelected => [...prevSelected, ...newSelections]);
          }

          // Iteration for selectedLL8 (tooth 38)
          if (result?.data?.data?.attachments?.['38']) {
            const attachmentsFor38 = result.data.data.attachments['38'];
            const newSelections = [];
            for (let i = 0; i < attachmentsFor38.length; i++) {
              newSelections.push(attachmentsFor38[i].Name);
            }
            setSelectedLL8(prevSelected => [...prevSelected, ...newSelections]);
          }


          toast.success(result?.data?.message, {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          toast.error(result?.data?.message, {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
          });
        }

      } catch (error) {
        toast.error('Unable to fetch details!', {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (alignerslower) {
      setDayslower(alignerslower * workdays);
    }
    if (alignersupper) {
      setDaysupper(alignersupper * workdays);
    }
  }, [workdays, alignerslower, alignersupper])

  return (
    <div className="dental-app">
      <div className='main-buttons'>
        <button className={`${handePage == 'two' ? 'active' : ''}`} onClick={() => setHandlePages('two')}>Two pages pdf</button>
        <button className={`${handePage == 'three' ? 'active' : ''}`} onClick={() => setHandlePages('three')}>Three pages pdf</button>
      </div>
      <div className="dental-wrapper">
        <div className="absoulute-name">
          <input type="text" value={caseName} onChange={(e) => setCaseName(e.target.value)} placeholder="Type case number here ..." />
        </div>
        <div className="pdf-wrapper" >

          <div className="width-custom" ref={pdfRef}>
            <div className="header-main">
              <div className="header-top mb-1">
                <div className="left">
                  <div className="title">PATIENT NAME :</div>
                  <div className="value" onClick={() => { setPatientModal((pre) => !pre); setPatient('') }}>
                    {patient}
                  </div>
                  {/* <div className="value">{patient}</div> */}
                  {patientModal && <div className="modal-fixed">

                    <div className="modal">
                      <div className="close" onClick={() => setPatientModal(false)}>
                        <IoIosCloseCircleOutline />
                      </div>
                      <div className="label-main">Enter  Patient Name</div>
                      <div>

                        <input type="text"
                          value={patient} className="input" onChange={(e) => setPatient(e.target.value)} />
                      </div>

                      <div className="buttons">

                        <button className="submit" onClick={() => setPatientModal(false)}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>}
                </div>
                <div>
                  <div className="flex mb-1">
                    <div className="titlee">Date :</div>
                    <div className="valuee">
                      {formattedDate}
                    </div>
                  </div>
                  <div className="flex mb-1">
                    <div className="titlee">Clinic :</div>
                    <div className="value" onClick={() => setClientModal((pre) => !pre)}>

                      {client}

                    </div>
                    {clientModal && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setClientModal(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter  Client Name</div>
                        <div>

                          <input type="text"
                            value={client} className="input" onChange={(e) => setClient(e.target.value)} />
                        </div>

                        <div className="buttons">

                          <button className="submit" onClick={() => { setClientModal(false); localStorage.setItem('clientName', client) }}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div className="overview mb-1">
                <span>{client}</span>Treatment Overview
              </div>
            </div>
            <div className="teeth-wrapper mb-5">
              <div className="text-left">RIGHT</div>
              <div className="text-right">LEFT</div>
              <div className="upper-teeth">

                {/* Upper teeth right start here */}
                <div className="right">
                  <div className="tooth-wrapper">
                    {modalNumber == '8' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR8}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR8}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR8}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR8}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR8}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR8}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR8}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR8}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR8}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR8}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 3*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP8.step1 ? 'active' : ''}`} onClick={() => setModalAP8((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP8.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP8.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP8 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP8(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP8.step1} className="input" onChange={handleAP8} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP8({}); setModalAP8(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP8(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth8"
                      onClick={() => modalNumberFunction('8')}
                    >
                      {uniqueUR8?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">8</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP1.width || IRP1.step) ? 'active' : ''}`} onClick={() => setModal1((pre) => !pre)}>
                      {(IRP1.width || IRP1.step) && <div className="data">
                        <div>{IRP1.width}mm</div>
                        <div> &lt;# {IRP1.step}</div>
                      </div>}
                    </div>

                    {modal1 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal1(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP1.width} className="input" onChange={handleIRP1} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP1.step} className="input" onChange={handleIRP1} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP1({}); setModal1(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal1(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '7' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR7}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR7}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR7}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR7}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR7}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR7}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR7}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR7}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR7}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR7}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 7*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP7.step1 ? 'active' : ''}`} onClick={() => setModalAP7((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP7.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP7.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP7 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP7(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP7.step1} className="input" onChange={handleAP7} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP7({}); setModalAP7(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP7(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth7"
                      onClick={() => modalNumberFunction('7')}
                    >
                      {uniqueUR7?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">7</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP2.width || IRP2.step) ? 'active' : ''}`} onClick={() => setModal2((pre) => !pre)}>
                      {(IRP2.width || IRP2.step) && <div className="data">
                        <div>{IRP2.width}mm</div>
                        <div> &lt;# {IRP2.step}</div>
                      </div>}
                    </div>

                    {modal2 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal2(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP2.width} className="input" onChange={handleIRP2} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP2.step} className="input" onChange={handleIRP2} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP2({}); setModal2(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal2(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '6' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR6}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR6}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR6}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR6}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR6}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR6}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR6}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR6}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR6}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR6}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 6*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP6.step1 ? 'active' : ''}`} onClick={() => setModalAP6((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP6.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP6.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP6 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP6(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP6.step1} className="input" onChange={handleAP6} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP6({}); setModalAP6(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP6(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth6"
                      onClick={() => modalNumberFunction('6')}
                    >
                      {uniqueUR6?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">6</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP3.width || IRP3.step) ? 'active' : ''}`} onClick={() => setModal3((pre) => !pre)}>
                      {(IRP3.width || IRP3.step) && <div className="data">
                        <div>{IRP3.width}mm</div>
                        <div> &lt;# {IRP3.step}</div>
                      </div>}
                    </div>

                    {modal3 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal3(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP3.width} className="input" onChange={handleIRP3} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP3.step} className="input" onChange={handleIRP3} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP3({}); setModal3(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal3(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '5' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR5}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR5}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR5}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR5}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR5}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR5}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR5}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR5}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR5}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR5}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 5*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP5.step1 ? 'active' : ''}`} onClick={() => setModalAP5((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP5.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP5.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP5 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP5(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP5.step1} className="input" onChange={handleAP5} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP5({}); setModalAP5(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP5(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth5"
                      onClick={() => modalNumberFunction('5')}
                    >
                      {uniqueUR5?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">5</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP4.width || IRP4.step) ? 'active' : ''}`} onClick={() => setModal4((pre) => !pre)}>
                      {(IRP4.width || IRP4.step) && <div className="data">
                        <div>{IRP4.width}mm</div>
                        <div> &lt;# {IRP4.step}</div>
                      </div>}
                    </div>

                    {modal4 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal4(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP4.width} className="input" onChange={handleIRP4} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP4.step} className="input" onChange={handleIRP4} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP4({}); setModal4(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal4(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '4' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR4}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR4}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR4}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR4}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR4}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR4}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR4}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR4}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR4}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR4}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}


                    {/* Attachment-line 4*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP4.step1 ? 'active' : ''}`} onClick={() => setModalAP4((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP4.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP4.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP4 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP4(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP4.step1} className="input" onChange={handleAP4} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP4({}); setModalAP4(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP4(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth4"
                      onClick={() => modalNumberFunction('4')}
                    >
                      {uniqueUR4?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">4</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP5.width || IRP5.step) ? 'active' : ''}`} onClick={() => setModal5((pre) => !pre)}>
                      {(IRP5.width || IRP5.step) && <div className="data">
                        <div>{IRP5.width}mm</div>
                        <div> &lt;# {IRP5.step}</div>
                      </div>}
                    </div>

                    {modal5 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal5(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP5.width} className="input" onChange={handleIRP5} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP5.step} className="input" onChange={handleIRP5} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP5({}); setModal5(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal5(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '3' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR3}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR3}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR3}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR3}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR3}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR3}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR3}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR3}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR3}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR3}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}


                    {/* pressure-line 3*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP3.step1 || PP3.step2) ? 'active' : ''}`} onClick={() => setModalpp3((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP3.step1 || PP3.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP3.step1} - {PP3.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp3 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp3(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP3.step1} className="input" onChange={handlePP3} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP3.step2} className="input" onChange={handlePP3} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP3({}); setModalpp3(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp3(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>


                    {/* Attachment-line 3*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP3.step1 ? 'active' : ''}`} onClick={() => setModalAP3((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP3.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP3.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP3 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP3(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP3.step1} className="input" onChange={handleAP3} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP3({}); setModalAP3(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP3(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth3"
                      onClick={() => modalNumberFunction('3')}
                    >
                      {uniqueUR3?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">3</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP6.width || IRP6.step) ? 'active' : ''}`} onClick={() => setModal6((pre) => !pre)}>
                      {(IRP6.width || IRP6.step) && <div className="data">
                        <div>{IRP6.width}mm</div>
                        <div> &lt;# {IRP6.step}</div>
                      </div>}
                    </div>

                    {modal6 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal6(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP6.width} className="input" onChange={handleIRP6} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP6.step} className="input" onChange={handleIRP6} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP6({}); setModal6(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal6(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '2' && (
                      <ul className="options">
                        <div className="close" onClick={() => modalNumberFunction('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR2}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR2}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR2}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR2}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR2}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR2}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR2}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR2}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR2}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR2}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* pressure-line 2*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP2.step1 || PP2.step2) ? 'active' : ''}`} onClick={() => setModalpp2((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP2.step1 || PP2.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP2.step1} - {PP2.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp2 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp2(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP2.step1} className="input" onChange={handlePP2} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP2.step2} className="input" onChange={handlePP2} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP2({}); setModalpp2(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp2(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 2*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP2.step1 ? 'active' : ''}`} onClick={() => setModalAP2((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP2.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP2.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP2 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP2(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP2.step1} className="input" onChange={handleAP2} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP2({}); setModalAP2(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP2(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth2"
                      onClick={() => modalNumberFunction('2')}
                    >
                      {uniqueUR2?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">2</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP7.width || IRP7.step) ? 'active' : ''}`} onClick={() => setModal7((pre) => !pre)}>
                      {(IRP7.width || IRP7.step) && <div className="data">
                        <div>{IRP7.width}mm</div>
                        <div> &lt;# {IRP7.step}</div>
                      </div>}
                    </div>

                    {modal7 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal7(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP7.width} className="input" onChange={handleIRP7} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP7.step} className="input" onChange={handleIRP7} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP7({}); setModal7(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal7(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '1' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUR1}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUR1}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUR1}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUR1}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUR1}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUR1}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUR1}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUR1}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUR1}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUR1}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}



                    {/* pressure-line 1*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP1.step1 || PP1.step2) ? 'active' : ''}`} onClick={() => setModalpp1((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP1.step1 || PP1.step2) && <div className="data">
                            <div>P.P</div>
                            <div> <span>{PP1.step1} - {PP1.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp1 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp1(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP1.step1} className="input" onChange={handlePP1} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP1.step2} className="input" onChange={handlePP1} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP1({}); setModalpp1(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp1(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 1*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP1.step1 ? 'active' : ''}`} onClick={() => setModalAP1((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP1.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP1.step1} </span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalAP1 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP1(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP1.step1} className="input" onChange={handleAP1} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP1({}); setModalAP1(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP1(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth1"
                      onClick={() => modalNumberFunction('1')}
                    >



                      {uniqueUR1?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">1</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP29.width || IRP29.step) ? 'active' : ''}`} onClick={() => setModal29((pre) => !pre)}>
                      {(IRP29.width || IRP29.step) && <div className="data">
                        <div>{IRP29.width}mm</div>
                        <div> &lt;# {IRP29.step}</div>
                      </div>}
                    </div>

                    {modal29 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal29(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP29.width} className="input" onChange={handleIRP29} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP29.step} className="input" onChange={handleIRP29} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP29({}); setModal29(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal29(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                </div>
                {/* upper teeth left start here */}

                <div className="right left">
                  <>
                    <div className={`line-point ${(IRP30.width || IRP30.step) ? 'active' : ''}`} onClick={() => setModal30((pre) => !pre)}>
                      {(IRP30.width || IRP30.step) && <div className="data">
                        <div>{IRP30.width}mm</div>
                        <div> &lt;# {IRP30.step}</div>
                      </div>}
                    </div>

                    {modal30 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal30(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP30.width} className="input" onChange={handleIRP30} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP30.step} className="input" onChange={handleIRP30} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP30({}); setModal30(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal30(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '9' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL1}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL1}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL1}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL1}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL1}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL1}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL1}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL1}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL1}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL1}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* pressure-line 1*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP4.step1 || PP4.step2) ? 'active' : ''}`} onClick={() => setModalpp4((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP4.step1 || PP4.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP4.step1} - {PP4.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp4 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp4(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP4.step1} className="input" onChange={handlePP4} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP4.step2} className="input" onChange={handlePP4} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP4({}); setModalpp4(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp4(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 9*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP9.step1 ? 'active' : ''}`} onClick={() => setModalAP9((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP9.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP9.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP9 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP9(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP9.step1} className="input" onChange={handleAP9} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP9({}); setModalAP9(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP9(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    <div
                      class="tooth tooth1"
                      onClick={() => modalNumberFunction('9')}
                    >
                      {uniqueUL1?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">1</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP8.width || IRP8.step) ? 'active' : ''}`} onClick={() => setModal8((pre) => !pre)}>
                      {(IRP8.width || IRP8.step) && <div className="data">
                        <div>{IRP8.width}mm</div>
                        <div> &lt;# {IRP8.step}</div>
                      </div>}
                    </div>

                    {modal8 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal8(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP8.width} className="input" onChange={handleIRP8} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP8.step} className="input" onChange={handleIRP8} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP8({}); setModal8(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal8(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '10' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL2}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL2}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL2}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL2}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL2}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL2}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL2}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL2}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL2}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL2}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* pressure-line 2*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP5.step1 || PP5.step2) ? 'active' : ''}`} onClick={() => setModalpp5((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP5.step1 || PP5.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP5.step1} - {PP5.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp5 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp5(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP5.step1} className="input" onChange={handlePP5} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP5.step2} className="input" onChange={handlePP5} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP5({}); setModalpp5(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp5(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 10*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP10.step1 ? 'active' : ''}`} onClick={() => setModalAP10((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP10.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP10.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP10 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP10(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP10.step1} className="input" onChange={handleAP10} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP10({}); setModalAP10(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP10(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth2"
                      onClick={() => modalNumberFunction('10')}
                    >
                      {uniqueUL2?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">2</div>
                  </div>

                  <>
                    <div className={`line-point ${(IRP9.width || IRP9.step) ? 'active' : ''}`} onClick={() => setModal9((pre) => !pre)}>
                      {(IRP9.width || IRP9.step) && <div className="data">
                        <div>{IRP9.width}mm</div>
                        <div> &lt;# {IRP9.step}</div>
                      </div>}
                    </div>

                    {modal9 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal9(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP9.width} className="input" onChange={handleIRP9} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP9.step} className="input" onChange={handleIRP9} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP9({}); setModal9(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal9(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '11' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL3}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL3}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL3}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL3}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL3}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL3}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL3}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL3}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL3}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL3}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}


                    {/* pressure-line 3*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP6.step1 || PP6.step2) ? 'active' : ''}`} onClick={() => setModalpp6((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP6.step1 || PP6.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP6.step1} - {PP6.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp6 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp6(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP6.step1} className="input" onChange={handlePP6} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP6.step2} className="input" onChange={handlePP6} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP6({}); setModalpp6(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp6(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 11*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP11.step1 ? 'active' : ''}`} onClick={() => setModalAP11((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP11.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP11.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP11 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP11(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP11.step1} className="input" onChange={handleAP11} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP11({}); setModalAP11(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP11(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth3"
                      onClick={() => modalNumberFunction('11')}
                    >
                      {uniqueUL3?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">3</div>
                  </div>

                  <>
                    <div className={`line-point ${(IRP10.width || IRP10.step) ? 'active' : ''}`} onClick={() => setModal10((pre) => !pre)}>
                      {(IRP10.width || IRP10.step) && <div className="data">
                        <div>{IRP10.width}mm</div>
                        <div> &lt;# {IRP10.step}</div>
                      </div>}
                    </div>

                    {modal10 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal10(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP10.width} className="input" onChange={handleIRP10} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP10.step} className="input" onChange={handleIRP10} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP10({}); setModal10(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal10(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '12' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL4}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL4}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL4}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL4}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL4}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL4}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL4}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL4}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL4}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL4}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 12*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP12.step1 ? 'active' : ''}`} onClick={() => setModalAP12((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP12.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP12.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP12 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP12(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP12.step1} className="input" onChange={handleAP12} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP12({}); setModalAP12(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP12(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth4"
                      onClick={() => modalNumberFunction('12')}
                    >
                      {uniqueUL4?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">4</div>
                  </div>

                  <>
                    <div className={`line-point ${(IRP11.width || IRP11.step) ? 'active' : ''}`} onClick={() => setModal11((pre) => !pre)}>
                      {(IRP11.width || IRP11.step) && <div className="data">
                        <div>{IRP11.width}mm</div>
                        <div> &lt;# {IRP11.step}</div>
                      </div>}
                    </div>

                    {modal11 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal11(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP11.width} className="input" onChange={handleIRP11} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP11.step} className="input" onChange={handleIRP11} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP11({}); setModal11(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal11(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '13' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL5}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL5}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL5}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL5}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL5}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL5}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL5}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL5}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL5}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL5}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 13*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP13.step1 ? 'active' : ''}`} onClick={() => setModalAP13((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP13.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP13.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP13 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP13(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP13.step1} className="input" onChange={handleAP13} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP13({}); setModalAP13(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP13(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth5"
                      onClick={() => modalNumberFunction('13')}
                    >
                      {uniqueUL5?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">5</div>
                  </div>

                  <>
                    <div className={`line-point ${(IRP12.width || IRP12.step) ? 'active' : ''}`} onClick={() => setModal12((pre) => !pre)}>
                      {(IRP12.width || IRP12.step) && <div className="data">
                        <div>{IRP12.width}mm</div>
                        <div> &lt;# {IRP12.step}</div>
                      </div>}
                    </div>

                    {modal12 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal12(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP12.width} className="input" onChange={handleIRP12} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP12.step} className="input" onChange={handleIRP12} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP12({}); setModal12(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal12(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '14' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL6}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL6}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL6}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL6}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL6}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL6}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL6}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL6}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL6}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL6}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 14*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP14.step1 ? 'active' : ''}`} onClick={() => setModalAP14((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP14.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP14.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP14 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP14(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP14.step1} className="input" onChange={handleAP14} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP14({}); setModalAP14(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP14(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth6"
                      onClick={() => modalNumberFunction('14')}
                    >
                      {uniqueUL6?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">6</div>
                  </div>

                  <>
                    <div className={`line-point ${(IRP13.width || IRP13.step) ? 'active' : ''}`} onClick={() => setModal13((pre) => !pre)}>
                      {(IRP13.width || IRP13.step) && <div className="data">
                        <div>{IRP13.width}mm</div>
                        <div> &lt;# {IRP13.step}</div>
                      </div>}
                    </div>

                    {modal13 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal13(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP13.width} className="input" onChange={handleIRP13} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP13.step} className="input" onChange={handleIRP13} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP13({}); setModal13(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal13(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '15' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL7}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL7}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL7}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL7}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL7}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL7}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL7}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL7}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL7}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL7}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 15*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP15.step1 ? 'active' : ''}`} onClick={() => setModalAP15((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP15.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP15.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP15 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP15(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP15.step1} className="input" onChange={handleAP15} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP15({}); setModalAP15(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP15(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth7"
                      onClick={() => modalNumberFunction('15')}
                    >
                      {uniqueUL7?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">7</div>
                  </div>
                  <>
                    <div className={`line-point ${(IRP14.width || IRP14.step) ? 'active' : ''}`} onClick={() => setModal14((pre) => !pre)}>
                      {(IRP14.width || IRP14.step) && <div className="data">
                        <div>{IRP14.width}mm</div>
                        <div> &lt;# {IRP14.step}</div>
                      </div>}
                    </div>

                    {modal14 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal14(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP14.width} className="input" onChange={handleIRP14} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP14.step} className="input" onChange={handleIRP14} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP14({}); setModal14(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal14(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '16' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleUL8}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleUL8}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleUL8}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleUL8}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleUL8}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleUL8}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleUL8}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleUL8}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleUL8}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleUL8}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 16*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP16.step1 ? 'active' : ''}`} onClick={() => setModalAP16((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP16.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP16.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP16 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP16(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP16.step1} className="input" onChange={handleAP16} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP16({}); setModalAP16(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP16(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth8"
                      onClick={() => modalNumberFunction('16')}
                    >
                      {uniqueUL8?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>
                    <div className="number">8</div>
                  </div>
                </div>
              </div>
              <div className="lower-teeth">

                {/* Lower right section starts here */}


                <div className="right">
                  <div className="tooth-wrapper">
                    {modalNumber == '17' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR8}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR8}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR8}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR8}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR8}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR8}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR8}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR8}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR8}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR8}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    <div className="number">8</div>
                    {/* Attachment-line 17*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP17.step1 ? 'active' : ''}`} onClick={() => setModalAP17((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP17.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP17.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP17 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP17(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP17.step1} className="input" onChange={handleAP17} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP17({}); setModalAP17(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP17(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div
                      class="tooth tooth8"
                      onClick={() => modalNumberFunction('17')}
                    >
                      {uniqueLR8?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP15.width || IRP15.step) ? 'active' : ''}`} onClick={() => setModal15((pre) => !pre)}>
                      {(IRP15.width || IRP15.step) && <div className="data">
                        <div>{IRP15.width}mm</div>
                        <div> &lt;# {IRP15.step}</div>
                      </div>}
                    </div>

                    {modal15 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal15(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP15.width} className="input" onChange={handleIRP15} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP15.step} className="input" onChange={handleIRP15} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP15({}); setModal15(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal15(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>


                  <div className="tooth-wrapper">
                    {modalNumber == '18' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR7}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR7}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR7}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR7}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR7}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR7}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR7}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR7}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR7}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR7}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 18*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP18.step1 ? 'active' : ''}`} onClick={() => setModalAP18((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP18.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP18.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP18 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP18(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP18.step1} className="input" onChange={handleAP18} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP18({}); setModalAP18(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP18(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">7</div>
                    <div
                      class="tooth tooth7"
                      onClick={() => modalNumberFunction('18')}
                    >
                      {uniqueLR7?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP16.width || IRP16.step) ? 'active' : ''}`} onClick={() => setModal16((pre) => !pre)}>
                      {(IRP16.width || IRP16.step) && <div className="data">
                        <div>{IRP16.width}mm</div>
                        <div> &lt;# {IRP16.step}</div>
                      </div>}
                    </div>

                    {modal16 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal16(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP16.width} className="input" onChange={handleIRP16} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP16.step} className="input" onChange={handleIRP16} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP16({}); setModal16(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal16(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '19' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR6}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR6}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR6}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR6}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR6}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR6}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR6}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR6}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR6}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR6}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 19*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP19.step1 ? 'active' : ''}`} onClick={() => setModalAP19((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP19.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP19.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP19 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP19(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP19.step1} className="input" onChange={handleAP19} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP19({}); setModalAP19(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP19(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">6</div>
                    <div
                      class="tooth tooth6"
                      onClick={() => modalNumberFunction('19')}
                    >
                      {uniqueLR6?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP17.width || IRP17.step) ? 'active' : ''}`} onClick={() => setModal17((pre) => !pre)}>
                      {(IRP17.width || IRP17.step) && <div className="data">
                        <div>{IRP17.width}mm</div>
                        <div> &lt;# {IRP17.step}</div>
                      </div>}
                    </div>

                    {modal17 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal17(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP17.width} className="input" onChange={handleIRP17} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP17.step} className="input" onChange={handleIRP17} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP17({}); setModal17(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal17(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '20' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR5}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR5}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR5}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR5}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR5}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR5}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR5}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR5}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR5}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR5}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}


                    {/* Attachment-line 20*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP20.step1 ? 'active' : ''}`} onClick={() => setModalAP20((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP20.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP20.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP20 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP20(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP20.step1} className="input" onChange={handleAP20} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP20({}); setModalAP20(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP20(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">5</div>
                    <div
                      class="tooth tooth5"
                      onClick={() => modalNumberFunction('20')}
                    >
                      {uniqueLR5?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP18.width || IRP18.step) ? 'active' : ''}`} onClick={() => setModal18((pre) => !pre)}>
                      {(IRP18.width || IRP18.step) && <div className="data">
                        <div>{IRP18.width}mm</div>
                        <div> &lt;# {IRP18.step}</div>
                      </div>}
                    </div>

                    {modal18 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal18(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP18.width} className="input" onChange={handleIRP18} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP18.step} className="input" onChange={handleIRP18} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP18({}); setModal18(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal18(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '21' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR4}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR4}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR4}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR4}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR4}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR4}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR4}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR4}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR4}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR4}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 21*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP21.step1 ? 'active' : ''}`} onClick={() => setModalAP21((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP21.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP21.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP21 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP21(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP21.step1} className="input" onChange={handleAP21} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP21({}); setModalAP21(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP21(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">4</div>
                    <div
                      class="tooth tooth4"
                      onClick={() => modalNumberFunction('21')}
                    >
                      {uniqueLR4?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP19.width || IRP19.step) ? 'active' : ''}`} onClick={() => setModal19((pre) => !pre)}>
                      {(IRP19.width || IRP19.step) && <div className="data">
                        <div>{IRP19.width}mm</div>
                        <div> &lt;# {IRP19.step}</div>
                      </div>}
                    </div>

                    {modal19 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal19(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP19.width} className="input" onChange={handleIRP19} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP19.step} className="input" onChange={handleIRP19} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP19({}); setModal19(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal19(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '22' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR3}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR3}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR3}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR3}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR3}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR3}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR3}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR3}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR3}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR3}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* pressure-line 7*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP7.step1 || PP7.step2) ? 'active' : ''}`} onClick={() => setModalpp7((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP7.step1 || PP7.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP7.step1} - {PP7.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp7 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp7(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP7.step1} className="input" onChange={handlePP7} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP7.step2} className="input" onChange={handlePP7} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP7({}); setModalpp7(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp7(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 22*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP22.step1 ? 'active' : ''}`} onClick={() => setModalAP22((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP22.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP22.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP22 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP22(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP22.step1} className="input" onChange={handleAP22} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP22({}); setModalAP22(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP22(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">3</div>
                    <div
                      class="tooth tooth3"
                      onClick={() => modalNumberFunction('22')}
                    >
                      {uniqueLR3?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP20.width || IRP20.step) ? 'active' : ''}`} onClick={() => setModal20((pre) => !pre)}>
                      {(IRP20.width || IRP20.step) && <div className="data">
                        <div>{IRP20.width}mm</div>
                        <div> &lt;# {IRP20.step}</div>
                      </div>}
                    </div>

                    {modal20 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal20(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP20.width} className="input" onChange={handleIRP20} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP20.step} className="input" onChange={handleIRP20} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP20({}); setModal20(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal20(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '23' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR2}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR2}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR2}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR2}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR2}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR2}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR2}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR2}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR2}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR2}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* pressure-line 8*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP8.step1 || PP8.step2) ? 'active' : ''}`} onClick={() => setModalpp8((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP8.step1 || PP8.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP8.step1} - {PP8.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp8 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp8(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP8.step1} className="input" onChange={handlePP8} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP8.step2} className="input" onChange={handlePP8} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP8({}); setModalpp8(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp8(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 23*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP23.step1 ? 'active' : ''}`} onClick={() => setModalAP23((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP23.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP23.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP23 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP23(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP23.step1} className="input" onChange={handleAP23} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP23({}); setModalAP23(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP23(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">2</div>
                    <div
                      class="tooth tooth2"
                      onClick={() => modalNumberFunction('23')}
                    >
                      {uniqueLR2?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP21.width || IRP21.step) ? 'active' : ''}`} onClick={() => setModal21((pre) => !pre)}>
                      {(IRP21.width || IRP21.step) && <div className="data">
                        <div>{IRP21.width}mm</div>
                        <div> &lt;# {IRP21.step}</div>
                      </div>}
                    </div>

                    {modal21 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal21(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP21.width} className="input" onChange={handleIRP21} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP21.step} className="input" onChange={handleIRP21} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP21({}); setModal21(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal21(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>
                  <div className="tooth-wrapper">
                    {modalNumber == '24' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLR1}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLR1}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLR1}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLR1}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLR1}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLR1}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLR1}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLR1}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLR1}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLR1}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* pressure-line 9*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP9.step1 || PP9.step2) ? 'active' : ''}`} onClick={() => setModalpp9((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP9.step1 || PP9.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP9.step1} - {PP9.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp9 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp9(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP9.step1} className="input" onChange={handlePP9} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP9.step2} className="input" onChange={handlePP9} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP9({}); setModalpp9(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp9(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 24*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP24.step1 ? 'active' : ''}`} onClick={() => setModalAP24((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP24.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP24.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP24 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP24(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP24.step1} className="input" onChange={handleAP24} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP24({}); setModalAP24(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP24(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">1</div>
                    <div
                      class="tooth tooth1"
                      onClick={() => modalNumberFunction('24')}
                    >
                      {uniqueLR1?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP31.width || IRP31.step) ? 'active' : ''}`} onClick={() => setModal31((pre) => !pre)}>
                      {(IRP31.width || IRP31.step) && <div className="data">
                        <div>{IRP31.width}mm</div>
                        <div> &lt;# {IRP31.step}</div>
                      </div>}
                    </div>

                    {modal31 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal31(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP31.width} className="input" onChange={handleIRP31} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP31.step} className="input" onChange={handleIRP31} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP31({}); setModal31(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal31(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                </div>

                {/* Lower left section starts here */}
                <div className="right left">
                  <>
                    <div className={`line-point ${(IRP32.width || IRP32.step) ? 'active' : ''}`} onClick={() => setModal32((pre) => !pre)}>
                      {(IRP32.width || IRP32.step) && <div className="data">
                        <div>{IRP32.width}mm</div>
                        <div> &lt;# {IRP32.step}</div>
                      </div>}
                    </div>

                    {modal32 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal32(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP32.width} className="input" onChange={handleIRP32} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP32.step} className="input" onChange={handleIRP32} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP32({}); setModal32(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal32(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '25' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL1}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL1}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL1}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL1}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL1}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL1}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL1}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL1}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL1}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL1}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* pressure-line 10*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP10.step1 || PP10.step2) ? 'active' : ''}`} onClick={() => setModalpp10((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP10.step1 || PP10.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP10.step1} - {PP10.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp10 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp10(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP10.step1} className="input" onChange={handlePP10} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP10.step2} className="input" onChange={handlePP10} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP10({}); setModalpp10(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp10(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 25*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP25.step1 ? 'active' : ''}`} onClick={() => setModalAP25((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP25.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP25.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP25 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP25(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP25.step1} className="input" onChange={handleAP25} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP25({}); setModalAP25(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP25(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">1</div>
                    <div
                      class="tooth tooth1"
                      onClick={() => modalNumberFunction('25')}
                    >
                      {uniqueLL1?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP22.width || IRP22.step) ? 'active' : ''}`} onClick={() => setModal22((pre) => !pre)}>
                      {(IRP22.width || IRP22.step) && <div className="data">
                        <div>{IRP22.width}mm</div>
                        <div> &lt;# {IRP22.step}</div>
                      </div>}
                    </div>

                    {modal22 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal22(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP22.width} className="input" onChange={handleIRP22} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP22.step} className="input" onChange={handleIRP22} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP22({}); setModal22(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal22(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '26' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL2}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL2}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL2}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL2}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL2}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL2}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL2}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL2}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL2}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL2}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* pressure-line 11*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP11.step1 || PP11.step2) ? 'active' : ''}`} onClick={() => setModalpp11((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP11.step1 || PP11.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP11.step1} - {PP11.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp11 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp11(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP11.step1} className="input" onChange={handlePP11} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP11.step2} className="input" onChange={handlePP11} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP11({}); setModalpp11(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp11(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>

                    {/* Attachment-line 26*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP26.step1 ? 'active' : ''}`} onClick={() => setModalAP26((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP26.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP26.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP26 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP26(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP26.step1} className="input" onChange={handleAP26} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP26({}); setModalAP26(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP26(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">2</div>
                    <div
                      class="tooth tooth2"
                      onClick={() => modalNumberFunction('26')}
                    >
                      {uniqueLL2?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>
                  <>
                    <div className={`line-point ${(IRP23.width || IRP23.step) ? 'active' : ''}`} onClick={() => setModal23((pre) => !pre)}>
                      {(IRP23.width || IRP23.step) && <div className="data">
                        <div>{IRP23.width}mm</div>
                        <div> &lt;# {IRP23.step}</div>
                      </div>}
                    </div>

                    {modal23 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal23(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP23.width} className="input" onChange={handleIRP23} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP23.step} className="input" onChange={handleIRP23} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP23({}); setModal23(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal23(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '27' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL3}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL3}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL3}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL3}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL3}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL3}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL3}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL3}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL3}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL3}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* pressure-line 12*/}
                    <>
                      <div className={`pressure-line-wrapper ${(PP12.step1 || PP12.step2) ? 'active' : ''}`} onClick={() => setModalpp12((pre) => !pre)}>
                        <div className="pressure-line">
                          {(PP12.step1 || PP12.step2) && <div className="data">
                            <div> P.P</div>
                            <div> <span>{PP12.step1} - {PP12.step2}</span> </div>
                          </div>}
                        </div>
                      </div>






                      {modalpp12 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalpp12(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter Pressure Points</div>
                          <div>
                            <label htmlFor="">Initial step</label>
                            <input type="number" min={0} name="step1"
                              value={PP12.step1} className="input" onChange={handlePP12} />
                          </div>
                          <div>
                            <label htmlFor="">Final step</label>
                            <input type="number" min={0} name="step2"
                              value={PP12.step2} className="input" onChange={handlePP12} />
                          </div>
                          <div className="buttons">
                            <button className="cancel" onClick={() => { setPP12({}); setModalpp12(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalpp12(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>


                    {/* Attachment-line 27*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP27.step1 ? 'active' : ''}`} onClick={() => setModalAP27((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP27.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP27.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP27 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP27(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP27.step1} className="input" onChange={handleAP27} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP27({}); setModalAP27(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP27(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">3</div>
                    <div
                      class="tooth tooth3"
                      onClick={() => modalNumberFunction('27')}
                    >
                      {uniqueLL3?.map((image) => (
                        <img className="test" key={image} src={image} alt={image} />
                      ))}


                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP24.width || IRP24.step) ? 'active' : ''}`} onClick={() => setModal24((pre) => !pre)}>
                      {(IRP24.width || IRP24.step) && <div className="data">
                        <div>{IRP24.width}mm</div>
                        <div> &lt;# {IRP24.step}</div>
                      </div>}
                    </div>

                    {modal24 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal24(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP24.width} className="input" onChange={handleIRP24} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP24.step} className="input" onChange={handleIRP24} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP24({}); setModal24(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal24(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '28' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL4}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL4}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL4}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL4}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL4}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL4}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL4}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL4}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL4}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL4}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 28*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP28.step1 ? 'active' : ''}`} onClick={() => setModalAP28((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP28.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP28.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP28 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP28(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP28.step1} className="input" onChange={handleAP28} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP28({}); setModalAP28(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP28(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">4</div>
                    <div
                      class="tooth tooth4"
                      onClick={() => modalNumberFunction('28')}
                    >
                      {uniqueLL4?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP25.width || IRP25.step) ? 'active' : ''}`} onClick={() => setModal25((pre) => !pre)}>
                      {(IRP25.width || IRP25.step) && <div className="data">
                        <div>{IRP25.width}mm</div>
                        <div> &lt;# {IRP25.step}</div>
                      </div>}
                    </div>

                    {modal25 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal25(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP25.width} className="input" onChange={handleIRP25} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP25.step} className="input" onChange={handleIRP25} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP25({}); setModal25(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal25(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '29' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL5}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL5}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL5}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL5}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL5}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL5}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL5}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL5}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL5}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL5}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 29*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP29.step1 ? 'active' : ''}`} onClick={() => setModalAP29((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP29.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP29.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP29 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP29(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP29.step1} className="input" onChange={handleAP29} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP29({}); setModalAP29(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP29(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">5</div>
                    <div
                      class="tooth tooth5"
                      onClick={() => modalNumberFunction('29')}
                    >
                      {uniqueLL5?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP26.width || IRP26.step) ? 'active' : ''}`} onClick={() => setModal26((pre) => !pre)}>
                      {(IRP26.width || IRP26.step) && <div className="data">
                        <div>{IRP26.width}mm</div>
                        <div> &lt;# {IRP26.step}</div>
                      </div>}
                    </div>

                    {modal26 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal26(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP26.width} className="input" onChange={handleIRP26} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP26.step} className="input" onChange={handleIRP26} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP26({}); setModal26(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal26(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>


                  <div className="tooth-wrapper">
                    {modalNumber == '30' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL6}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL6}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL6}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL6}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL6}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL6}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL6}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL6}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL6}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL6}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 30*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP30.step1 ? 'active' : ''}`} onClick={() => setModalAP30((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP30.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP30.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP30 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP30(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP30.step1} className="input" onChange={handleAP30} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP30({}); setModalAP30(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP30(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">6</div>
                    <div
                      class="tooth tooth6"
                      onClick={() => modalNumberFunction('30')}
                    >
                      {uniqueLL6?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP27.width || IRP27.step) ? 'active' : ''}`} onClick={() => setModal27((pre) => !pre)}>
                      {(IRP27.width || IRP27.step) && <div className="data">
                        <div>{IRP27.width}mm</div>
                        <div> &lt;# {IRP27.step}</div>
                      </div>}
                    </div>

                    {modal27 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal27(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP27.width} className="input" onChange={handleIRP27} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP27.step} className="input" onChange={handleIRP27} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP27({}); setModal27(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal27(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>

                  <div className="tooth-wrapper">
                    {modalNumber == '31' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL7}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL7}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL7}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL7}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL7}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL7}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL7}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL7}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL7}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL7}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}

                    {/* Attachment-line 31*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP31.step1 ? 'active' : ''}`} onClick={() => setModalAP31((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP31.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP31.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP31 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP31(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP31.step1} className="input" onChange={handleAP31} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP31({}); setModalAP31(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP31(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">7</div>
                    <div
                      class="tooth tooth7"
                      onClick={() => modalNumberFunction('31')}
                    >
                      {uniqueLL7?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>

                  <>
                    <div className={`line-point ${(IRP28.width || IRP28.step) ? 'active' : ''}`} onClick={() => setModal28((pre) => !pre)}>
                      {(IRP28.width || IRP28.step) && <div className="data">
                        <div>{IRP28.width}mm</div>
                        <div> &lt;# {IRP28.step}</div>
                      </div>}
                    </div>

                    {modal28 && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setModal28(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter size of IPR</div>
                        <div>
                          <label htmlFor="">Milimeter</label>
                          <input type="number" min={0} step="0.1" name="width"
                            value={IRP28.width} className="input" onChange={handleIRP28} />
                        </div>
                        <div>
                          <label htmlFor="">After step</label>
                          <input type="number" min={0} name="step"
                            value={IRP28.step} className="input" onChange={handleIRP28} />
                        </div>
                        <div className="buttons">
                          <button className="cancel" onClick={() => { setIRP28({}); setModal28(false) }}>
                            CLEAR
                          </button>
                          <button className="submit" onClick={() => setModal28(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </>


                  <div className="tooth-wrapper">
                    {modalNumber == '32' && (
                      <ul className="options">
                        <div className="close" onClick={() => setModalNumber('100')}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Attachment"
                              onChange={handleLL8}
                            />
                            <span>Attachment</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Missing Tooth"
                              onChange={handleLL8}
                            />
                            <span>Missing Tooth</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Buccal"
                              onChange={handleLL8}
                            />
                            <span>Button Cutout Buccal</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Button Cutout Lingual"
                              onChange={handleLL8}
                            />
                            <span>Button Cutout Lingual</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Extraction"
                              onChange={handleLL8}
                            />
                            <span>Extraction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Biteramp"
                              onChange={handleLL8}
                            />
                            <span>Biteramp</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Left"
                              onChange={handleLL8}
                            />
                            <span>Elastic Hook Left</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Elastic Hook Right"
                              onChange={handleLL8}
                            />
                            <span>Elastic Hook Right</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="Pressure Point"
                              onChange={handleLL8}
                            />
                            <span>Pressure Point</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="">
                            <input
                              type="checkbox"
                              value="PowerRidge"
                              onChange={handleLL8}
                            />
                            <span>PowerRidge</span>
                          </label>
                        </li>
                      </ul>
                    )}
                    {/* Attachment-line 32*/}
                    <>
                      <div className={`attachment-line-wrapper ${AP32.step1 ? 'active' : ''}`} onClick={() => setModalAP32((pre) => !pre)}>
                        <div className="attachment-line">
                          {AP32.step1 && <div className="data">

                            <div className="d-flex"> <i class="fa-solid fa-caret-up"></i> <span> &lt; </span> <span>{AP32.step1} </span> </div>
                          </div>}
                        </div>
                      </div>



                      {modalAP32 && <div className="modal-fixed">

                        <div className="modal">
                          <div className="close" onClick={() => setModalAP32(false)}>
                            <IoIosCloseCircleOutline />
                          </div>
                          <div className="label-main">Enter  Points</div>
                          <div>
                            <label htmlFor="">Step</label>
                            <input type="number" min={0} name="step1"
                              value={AP32.step1} className="input" onChange={handleAP32} />
                          </div>

                          <div className="buttons">
                            <button className="cancel" onClick={() => { setAP32({}); setModalAP32(false) }}>
                              CLEAR
                            </button>
                            <button className="submit" onClick={() => setModalAP32(false)}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>}
                    </>
                    <div className="number">8</div>
                    <div
                      class="tooth tooth8"
                      onClick={() => modalNumberFunction('32')}
                    >
                      {uniqueLL8?.map((image) => (
                        <img key={image} src={image} alt={image} />
                      ))}
                    </div>

                  </div>


                </div>
              </div>
            </div>




            <div className="center-part mb-5">
              <div className="left">
                <div className="flex mb-2">
                  <div className="titlee">Total of Aligners :</div>
                  <div>
                    <div className="valuee flex mb-1" onClick={() => { setAlignupperModal((pre) => !pre); setAlignersupper('') }}>
                      <span className="normal">Upper #</span>   <span >
                        {alignersupper}
                      </span>

                    </div>
                    {alignupperModal && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setAlignupperModal(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter  Upper Aligners</div>
                        <div>

                          <input type="text"
                            value={alignersupper} className="input" onChange={(e) => setAlignersupper(e.target.value)} />
                        </div>

                        <div className="buttons">

                          <button className="submit" onClick={() => setAlignupperModal(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                    <div className="valuee flex mb-1" onClick={() => { setAllignlowerModal((pre) => !pre); setAlignerslower('') }}>
                      <span className="normal">Lower #</span>   <span >
                        {alignerslower}
                      </span>

                    </div>
                    {allignlowerModal && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => { setAllignlowerModal(false) }}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter  Lower Aligners</div>
                        <div>

                          <input type="text"
                            value={alignerslower} className="input" onChange={(e) => setAlignerslower(e.target.value)} />
                        </div>

                        <div className="buttons">

                          <button className="submit" onClick={() => setAllignlowerModal(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>
                <div className="flex mb-2">
                  <div className="titlee">Est. Treatment Time :</div>
                  <div>
                    <div className="valuee flex mb-1" onClick={() => { setdaysupperModal((pre) => !pre); setDaysupper('') }}>
                      <span className="normal">Upper #</span>   <span >
                        {daysupper} Days
                      </span>

                    </div>
                    {daysupperModal && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setdaysupperModal(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter  Days</div>
                        <div>

                          <input type="text"
                            value={daysupper} className="input" onChange={(e) => setDaysupper(e.target.value)} />
                        </div>

                        <div className="buttons">

                          <button className="submit" onClick={() => setdaysupperModal(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                    <div className="valuee flex mb-1" onClick={() => { setdayslowerModal((pre) => !pre); setDayslower('') }}>
                      <span className="normal">Lower #</span>   <span >
                        {dayslower} Days
                      </span>

                    </div>
                    {dayslowerModal && <div className="modal-fixed">

                      <div className="modal">
                        <div className="close" onClick={() => setdayslowerModal(false)}>
                          <IoIosCloseCircleOutline />
                        </div>
                        <div className="label-main">Enter  Days</div>
                        <div>

                          <input type="text"
                            value={dayslower} className="input" onChange={(e) => setDayslower(e.target.value)} />
                        </div>

                        <div className="buttons">

                          <button className="submit" onClick={() => setdayslowerModal(false)}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>
                <div className="flex mb-1">
                  <div className="titlee" onClick={() => { setworkdaysModal((pre) => !pre); setWorkdays('') }}>
                    * Each Aligner need to be worn for
                    <span className="valuee"> {workdays} </span> days.


                  </div>
                  {workdaysModal && <div className="modal-fixed">

                    <div className="modal">
                      <div className="close" onClick={() => setworkdaysModal(false)}>
                        <IoIosCloseCircleOutline />
                      </div>
                      <div className="label-main">Enter  Days</div>
                      <div>

                        <input type="text"
                          value={workdays} className="input" onChange={(e) => setWorkdays(e.target.value)} />
                      </div>

                      <div className="buttons">

                        <button className="submit" onClick={() => setworkdaysModal(false)}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>}
                </div>
              </div>
              <div className="right">
                <div className="upper" style={{ marginTop: '5rem' }}>
                  <div className="d-flex" onClick={() => { setElasticModal((pre) => !pre); setElasticType('') }}>
                    <span className="titlee">Elastic Type</span>
                    <span className="valuee">
                      {elasticType}
                    </span>
                  </div>

                  {elasticModal && <div className="modal-fixed">

                    <div className="modal">
                      <div className="close" onClick={() => setElasticModal(false)}>
                        <IoIosCloseCircleOutline />
                      </div>
                      <div className="label-main">Elastic Type</div>
                      <div>

                        <input type="text"
                          value={elasticType} className="input" onChange={(e) => setElasticType(e.target.value)} />
                      </div>

                      <div className="buttons">

                        <button className="submit" onClick={() => setElasticModal(false)}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>}

                  <div className="d-flex" onClick={() => { setSizeModal((pre) => !pre); setSize('') }}>
                    <span className="titlee">Size :</span>
                    <span className="valuee">
                      {size}
                    </span>
                  </div>

                  {sizeModal && <div className="modal-fixed">

                    <div className="modal">
                      <div className="close" onClick={() => setSizeModal(false)}>
                        <IoIosCloseCircleOutline />
                      </div>
                      <div className="label-main">Enter Size</div>
                      <div>

                        <input type="text"
                          value={size} className="input" onChange={(e) => setSize(e.target.value)} />
                      </div>

                      <div className="buttons">

                        <button className="submit" onClick={() => setSizeModal(false)}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>}
                </div>
                <img src={LeftImage} alt="" />
              </div>
            </div>
          </div>

          <div className="width-custom" ref={specificElementRef}>
            <div className="header-main" >
              <div className="header-top mb-1">
                <div className="left">
                  <div className="title">PATIENT NAME :</div>
                  <div className="value">{patient}</div>
                </div>
                <div>
                  <div className="flex mb-1">
                    <div className="titlee">Date :</div>
                    <div className="valuee">{formattedDate}</div>
                  </div>
                  <div className="flex">
                    <div className="titlee">Clinic :</div>
                    <div className="valuee">{client}</div>
                  </div>
                </div>
              </div>
              <div className="overview mb-1">
                <span>{client}</span> Treatment Overview
              </div>
            </div>
            <div className="title">SMILE SUMMARY</div>
            <div className="small-images-wrapper">
              <div className="imagee">
                <div
                  className="close"
                  onClick={() => {
                    setInitialSmallUrl(null);
                  }}
                >
                  <IoIosCloseCircleOutline />
                </div>

                <div
                  className="image"
                  ref={initialSmall}
                  onPaste={handleInitialSmall}
                >
                  {initialSmallUrl ? (
                    <img src={initialSmallUrl} alt="Fetched Image" style={{ maxWidth: '100%', height: 'auto' }} />
                  ) : (
                    "Paste your image here."
                  )}
                </div>
              </div>
              <div className="imagee">
                <div
                  className="close"
                  onClick={() => {
                    setAfterSmallUrl(null);
                  }}
                >
                  <IoIosCloseCircleOutline />
                </div>

                <div
                  className="image"
                  ref={afterSmall}
                  onPaste={handleAfterSmall}
                >
                  {afterSmallUrl ? (
                    <img src={afterSmallUrl} alt="Fetched Image" style={{ maxWidth: '100%', height: 'auto' }} />
                  ) : (
                    "Paste your image here."
                  )}
                </div>
              </div>
            </div>
            <div className="small-images-wrapper">
              <div className="text">INITIAL POSITION</div>
              <div className="text">FINAL POSITION</div>
            </div>
            <div className="small-images-wrapper mb-4">


              <div className="imagee">
                <div
                  className="close"
                  onClick={() => {
                    setInitialLarge1Url(null);
                  }}
                >
                  <IoIosCloseCircleOutline />
                </div>

                <div
                  className="image"
                  ref={initialLarge1}
                  onPaste={handleInitialLarge1}
                >
                  {initialLarge1Url ? (
                    <img src={initialLarge1Url} alt="Fetched Image" style={{ maxWidth: '100%', height: 'auto' }} />
                  ) : (
                    "Paste your image here."
                  )}
                </div>
              </div>


              <div className="imagee">
                <div
                  className="close"
                  onClick={() => {
                    setAfterLarge1Url(null);
                  }}
                >
                  <IoIosCloseCircleOutline />
                </div>

                <div
                  className="image"
                  ref={afterLarge1}
                  onPaste={handleAfterLarge1}
                >
                  {/* Conditional Rendering: If we have a fetched image URL, show the image */}
                  {afterLarge1Url ? (
                    <img src={afterLarge1Url} alt="Fetched Image" style={{ maxWidth: '100%', height: 'auto' }} />
                  ) : (
                    // Otherwise, show the placeholder text (for pasting)
                    "Paste your image here."
                  )}
                </div>
              </div>


            </div>
            <div className="small-images-wrapper mb-4">


              <div className="imagee">
                <div
                  className="close"
                  onClick={() => {
                    setInitialLarge2Url(null);
                  }}
                >
                  <IoIosCloseCircleOutline />
                </div>

                <div
                  className="image"
                  ref={initialLarge2}
                  onPaste={handleInitialLarge2}
                >
                  {initialLarge2Url ? (
                    <img src={initialLarge2Url} alt="Fetched Image" style={{ maxWidth: '100%', height: 'auto' }} />
                  ) : (
                    "Paste your image here."
                  )}
                </div>
              </div>





              <div className="imagee">
                <div
                  className="close"
                  onClick={() => {
                    // When closing/clearing, also reset the image URL state.
                    // afterLarge2.current.innerHTML = "";
                    setAfterLarge2Url(null);
                  }}
                >
                  <IoIosCloseCircleOutline />
                </div>

                <div
                  className="image"
                  ref={afterLarge2}
                  onPaste={handleAfterLarge2}
                >
                  {/* Conditional Rendering: If we have a fetched image URL, show the image */}
                  {afterLarge2Url ? (
                    <img src={afterLarge2Url} alt="Fetched Image" style={{ maxWidth: '100%', height: 'auto' }} />
                  ) : (
                    // Otherwise, show the placeholder text (for pasting)
                    "Paste your image here."
                  )}
                </div>
              </div>

            </div>
          </div>
          {handePage == 'three' &&
            <div className="width-custom last-pagee" ref={specificElementRef2}>
              <div className="header-main mb-2">
                <div className="header-top mb-1">
                  <div className="left">
                    <div className="title">PATIENT NAME :</div>
                    <div className="value" >

                      {patient}

                    </div>

                  </div>
                  <div>
                    <div className="flex mb-1">
                      <div className="titlee">Date :</div>
                      <div className="valuee">
                        {formattedDate}
                      </div>
                    </div>

                  </div>
                </div>
                <div className="overview mb-1">
                  <span>{client}</span> Treatment Overview
                </div>
              </div>
              {movementModal && <div className="modal-fixed">

                <div className="modal">
                  <div className="close" onClick={() => setMovementModal(false)}>
                    <IoIosCloseCircleOutline />
                  </div>
                  <div className="label-main">Enter here</div>
                  <div>

                    <input type="text"
                      value={movementChart} className="input" onChange={(e) => setMovementChart(e.target.value)} />
                  </div>

                  <div className="buttons">

                    <button className="submit" onClick={() => setMovementModal(false)}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>}
              <div className="title" onClick={() => setMovementModal(true)}>{movementChart}</div>

              {hasMovementData ? (
                <div className="movement-chart-table-wrapper">
                  <div className="upper-movement-table">
                    <table>
                      <thead>
                        {/* Ensure THs are wrapped in a TR */}
                        <tr>
                          <th>Tooth</th>
                          {UPPER_TEETH_ORDER.map(toothNumber => (
                            <th key={toothNumber} className={upperHighlightedTeeth.has(toothNumber) ? 'darker-upper-header' : ''}>{toothNumber}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {movementChartUpperData && movementChartUpperData.map((row, index) => (
                          <tr key={index}>
                            {/* Metric Title column (no conditional highlighting here) */}
                            <td>{row.title}</td>

                            {/* Data columns: Apply 'highlight-value' class conditionally */}
                            {UPPER_TEETH_ORDER.map(toothNumber => {
                              const value = row[toothNumber];
                              const isPlusMinusRow = row.title.includes('+/-');

                              // Check if the value is non-null/non-empty
                              const isValuePresent = value !== null && value !== undefined && value !== '';

                              const shouldHighlight = isPlusMinusRow && isValuePresent;

                              return (
                                <td
                                  key={toothNumber}
                                  className={shouldHighlight ? 'highlight-value' : ''}
                                >
                                  {value || ''}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="lower-movement-table">
                    <table>
                      <thead>
                        {/* Ensure THs are wrapped in a TR */}
                        <tr>
                          <th>Tooth</th>
                          {LOWER_TEETH_ORDER.map(toothNumber => (
                            <th key={toothNumber} className={lowerHighlightedTeeth.has(toothNumber) ? 'darker-lower-header' : ''}>{toothNumber}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {movementChartLowerData && movementChartLowerData.map((row, index) => (
                          <tr key={index}>
                            {/* Metric Title column */}
                            <td>{row.title}</td>

                            {/* Data columns: Apply 'highlight-value' class conditionally */}
                            {LOWER_TEETH_ORDER.map(toothNumber => {
                              const value = row[toothNumber];
                              const isPlusMinusRow = row.title.includes('+/-');
                              const isValuePresent = value !== null && value !== undefined && value !== '';
                              const shouldHighlight = isPlusMinusRow && isValuePresent;

                              return (
                                <td
                                  key={toothNumber}
                                  className={shouldHighlight ? 'highlight-value' : ''}
                                >
                                  {value || ''}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                // --- Conditional Rendering: Render Placeholder (Your original code) ---
                <div className="chart-image-wrapper">
                  <div
                    className="close"
                    onClick={() => {
                      chartRef.current.innerHTML = "";
                    }}
                  >
                    <IoIosCloseCircleOutline />
                  </div>
                  <div
                    className="image"
                    ref={chartRef}
                    onPaste={handleChartRef}
                  >
                    Paste your image here.
                  </div>
                </div>
              )}
              {/* <div className="chart-image-wrapper">
            <div
              className="close"
              onClick={() => {
                chartRef.current.innerHTML = "";
              }}
            >
              <IoIosCloseCircleOutline />
            </div>
            <div
              className="image"
              ref={chartRef}
              onPaste={handleChartRef}
            >
              Paste your image here.
            </div>
          </div> */}

              <div className="title">IPR SUMMARY</div>
              <div className="large-image-wrapper mb-4">
                <div className="imagee">
                  <div
                    className="close"
                    onClick={() => {
                      iprRefLeft.current.innerHTML = "";
                    }}
                  >
                    <IoIosCloseCircleOutline />
                  </div>
                  <div
                    className="image"
                    ref={iprRefLeft}
                    onPaste={handleIprLeft}
                  >
                    Paste your image here.
                  </div>
                </div>
                <div className="imagee">
                  <div
                    className="close"
                    onClick={() => {
                      iprRefRight.current.innerHTML = "";
                    }}
                  >
                    <IoIosCloseCircleOutline />
                  </div>
                  <div className="image" ref={iprRefRight} onPaste={handleIprRight}>
                    Paste your image here.
                  </div>
                </div>
              </div>
              <div className="small-images-wrapper">
                <div className="text" onClick={() => { setStage1Modal((pre) => !pre); setStage1('') }}>IRP ON STAGE <span className="span">{stage1}</span></div>
                {stage1Modal && <div className="modal-fixed">

                  <div className="modal">
                    <div className="close" onClick={() => setStage1Modal(false)}>
                      <IoIosCloseCircleOutline />
                    </div>
                    <div className="label-main">Enter here</div>
                    <div>

                      <input type="text"
                        value={stage1} className="input" onChange={(e) => setStage1(e.target.value)} />
                    </div>

                    <div className="buttons">

                      <button className="submit" onClick={() => setStage1Modal(false)}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>}
                <div className="text" onClick={() => { setStage2Modal((pre) => !pre); setStage2('') }}>IRP ON STAGE <span className="span">{stage2}</span></div>

                {stage2Modal && <div className="modal-fixed">

                  <div className="modal">
                    <div className="close" onClick={() => setStage2Modal(false)}>
                      <IoIosCloseCircleOutline />
                    </div>
                    <div className="label-main">Enter here</div>
                    <div>

                      <input type="text"
                        value={stage2} className="input" onChange={(e) => setStage2(e.target.value)} />
                    </div>

                    <div className="buttons">

                      <button className="submit" onClick={() => setStage2Modal(false)}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          }
        </div>
        <div className="downlaod-button">
          <button onClick={generatePDF}>Generate PDF</button>
        </div>
      </div>
    </div>
  );
};

export default CasePlanUploadUpdate;
